// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:38.182Z
// Property: Traditions at Westmoore (ID: 6737460151191770)
// Collections: 23 amenities, 10 floorplans (live), 19 photos, 114 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191770",
  "property_external_id": "5026482",
  "property_zillow_url": "https://www.zillow.com/apartments/oklahoma-city-ok/traditions-at-westmoore/5hQvkG/",
  "property_apartments_url": "https://www.apartments.com/traditions-at-waterford-oklahoma-city-ok/es3w5vp",
  "property_google_business_url": "https://www.google.com/maps/place/Traditions+at+Westmoore/data=!4m2!3m1!1s0x0:0x753701d12623171b?sa=X&ved=2ahUKEwiqp8Wyv7ySAxX9g_0HHTnBIGQQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321126840",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "traditions-at-westmoore",
  "property_name": "Traditions at Westmoore",
  "property_website_url": "https://www.traditionswestmoore.com/",
  "property_domain": "https://www.traditionswestmoore.com/",
  "property_address": "12205 S Western Ave",
  "property_full_address": "12205 S Western Ave, Oklahoma City, OK 73170",
  "property_address_1": "12205 S Western Ave",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": "73170-5901",
  "property_address_zip": "73170",
  "property_address_country": "US",
  "property_address_county": "Cleveland County",
  "property_neighborhood_address": "South Oklahoma City",
  "property_address_latitude": "35.3456007",
  "property_address_longitude": "-97.5308167",
  "property_email": "traditionswestmoore@rreafresidential.com",
  "property_phone": "(405) 692-6300",
  "property_call_tracking_phone": "405-704-3399",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Traditions at Westmoore in Oklahoma City, where comfort meets convenience! Choose from spacious two and three-bedroom floor plans, and enjoy premium amenities like gas grills, a 24-hour fitness center, and two sparkling pools. Elevate your lifestyle in our gated community—your perfect home awaits!",
  "property_long_description": "Welcome to Traditions at Westmoore, your idyllic apartment community located in the heart of Oklahoma City, OK. Offering spacious two and three-bedroom floor plans, our apartments are thoughtfully designed with modern living in mind. Each residence features upgraded flooring and a private entry, ensuring that you feel right at home from the moment you walk through the door.\n\nAt Traditions at Westmoore, we pride ourselves on providing a plethora of exceptional amenities to enhance your lifestyle. Enjoy sunny days at our two sparkling pools, fire up the gas grills in our community BBQ area, or unwind by the gas fire pit with friends and family. For fitness enthusiasts, our 24-hour fitness center equipped with free weights and a basketball court will help you stay on track with your health goals.\n\nOur gated community ensures your safety and privacy, while amenities like ample parking, covered options, and an on-site car wash area make daily life effortless. Need assistance? Our 24-hour on-call maintenance and management team is always here to help.\n\nIn addition, our state-of-the-art business center and conference room offer the perfect space for remote work or meetings. Let your furry friends enjoy the newly designed dog park and take advantage of our direct access to the scenic Vulcan trail for outdoor adventures.\n\nFind your new home today at Traditions at Westmoore! Browse our availability or schedule a tour to explore our vibrant community and experience the ideal blend of comfort and convenience. Your next chapter starts here!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-494d-746c-8d63-73fdf81c39f3.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas outside a brick building.",
    "public_id": "019e84e4-494d-746c-8d63-73fdf81c39f3",
    "storage_key": "property/6737460151191770/019e84e4-494d-746c-8d63-73fdf81c39f3.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "200",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.5",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$150\nApplication Fee\n$75",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No breed restrictions. Each apartment may have up to 3 pets, with a limit of 2 dogs per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://traditionsatwestmoore.loftliving.com/login",
  "property_apply_now_url": "https://8921443.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-25a0-7698-be05-48251e80a21e.webp",
  "property_primary_logo_media": {
    "alt_text": "Traditions at Westmoore Apartment Homes logo",
    "public_id": "019e1e21-25a0-7698-be05-48251e80a21e",
    "storage_key": "property/6737460151191770/019e1e21-25a0-7698-be05-48251e80a21e.webp",
    "width": 499,
    "height": 83
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-24e8-7019-833d-9fcc8a4eac5b.webp",
  "property_secondary_logo_media": {
    "alt_text": "Traditions at Westmoore Apartment Homes logo.",
    "public_id": "019e1e21-24e8-7019-833d-9fcc8a4eac5b",
    "storage_key": "property/6737460151191770/019e1e21-24e8-7019-833d-9fcc8a4eac5b.webp",
    "width": 1463,
    "height": 217
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-3101-72ac-85db-39633a7a43d8.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Traditions at Westmoore Apartment Homes logo",
    "public_id": "019e84e4-3101-72ac-85db-39633a7a43d8",
    "storage_key": "property/6737460151191770/019e84e4-3101-72ac-85db-39633a7a43d8.webp",
    "width": 1463,
    "height": 217
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-25a0-7698-be05-48251e80a21e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Traditions at Westmoore Apartment Homes logo",
    "public_id": "019e1e21-25a0-7698-be05-48251e80a21e",
    "storage_key": "property/6737460151191770/019e1e21-25a0-7698-be05-48251e80a21e.webp",
    "width": 499,
    "height": 83
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "753 - 1203",
  "property_sqft_min": "753",
  "property_sqft_max": "1203",
  "property_price_range": "1073 - 1682",
  "property_price_min": "1073",
  "property_price_max": "1682",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/TraditionsatWestmoore",
  "property_instagram_url": "https://www.instagram.com/traditionswestmooreokc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJhy2tU1cTsocRGxcjJtEBN3U",
  "property_youtube_url": "https://www.youtube.com/watch?v=ZAy7ZTIfFLw",
  "property_yelp_url": "https://www.yelp.com/biz/traditions-at-westmoore-apartments-oklahoma-city",
  "property_tiktok_url": "https://www.tiktok.com/@traditionswestmoore",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Traditions at Westmoore",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Community",
  "property_home_amenities_blurb": "<p>Our pet-friendly community at Traditions at Westmoore Apartments in Oklahoma City, OK, is quietly nestled near Moore and within walking distance of schools, restaurants, parks, shopping, and hospitals. At our beautiful community, you will find comfortably designed <a href=\"/floor-plans/\">one-, two-, and three-bedroom apartment homes for rent</a> with bright open spaces, views from your patio or balcony, and thoughtful details to enhance each moment of your life. Enjoy extra storage in our garage rentals, and our hardwood floors, spacious walk-in closets, and breakfast bar. Play at the bark park with your dog! Workout at the fitness center and cool off in the swimming pool. Enjoy our coffee bar with Wi-Fi and exclusive resident events hosted by our lovely management!</p>",
  "property_home_floorplans_blurb": "<p>The great pet-friendly <a href=\"/floor-plans/\">apartment homes</a> of Traditions at Westmoore in Oklahoma City, Oklahoma, is where convenience and beauty are all in one community. Quietly nestled within South Oklahoma City near Moore and within walking distance of schools, restaurants, and medical offices makes our location a dream.</p>",
  "property_home_gallery_blurb": "Welcome to Traditions at Westmoore, where comfort meets convenience in Oklahoma City! Choose from spacious one, two, and three-bedroom floor plans featuring modern amenities like an inviting pool, fitness center, and picnic areas. From 24-hour maintenance to a vibrant clubhouse, every detail supports your ideal lifestyle. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Traditions at Westmoore in Oklahoma City, our vibrant neighborhood offers an array of local gems. From cozy eateries to lush parks, adventure awaits just outside your door. Dive into the community spirit—uncover your next favorite spot and see how our two and three-bedroom apartments are perfectly nestled within it.",
  "property_home_reviews_blurb": "At Traditions at Westmoore in Oklahoma City, residents rave about our friendly, responsive staff and the sense of community fostered by our unique enclosed stairwells. \"We all chat with each other now,\" says one happy resident. Experience a vibrant living atmosphere combined with spacious, well-maintained apartments. Join us today!",
  "property_neighborhood_blurb": "<p>The great pet-friendly <a href=\"/floor-plans/\">apartment homes</a> of Traditions at Westmoore in Oklahoma City, Oklahoma, is where convenience and beauty are all in one community. Quietly nestled within South Oklahoma City near Moore and within walking distance of schools, restaurants, and medical offices makes our location a dream.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>We have many impressive community features, including freebies like a coffee bar and clubhouse Wi-Fi. Beautiful landscaping adds sparkle to your home with attentive 24-hour emergency maintenance to handle all your needs, so <a href=\"/contact/\">schedule your tour</a> today and see what living in Oklahoma City, OK has to offer!</p>",
  "property_applynow_blurb": "Welcome to Traditions at Westmoore, where your ideal two or three-bedroom apartment awaits in Oklahoma City! Enjoy resort-style amenities including two sparkling pools, a dog park, and a fully-equipped 24-hour fitness center. Experience first-class living with 24/7 maintenance support. Start your journey—lease online today!",
  "property_contactus_blurb": "At Traditions at Westmoore in Oklahoma City, OK, our spacious two and three-bedroom floor plans are designed for modern living. With thoughtful layouts that cater to your lifestyle, finding your perfect home is easy. Have questions? Contact our leasing team today! Your new beginning awaits!",
  "property_faqs_blurb": "At Traditions at Westmoore in Oklahoma City, we offer meticulously designed two and three-bedroom floor plans to suit your lifestyle. Ready to delve into our community? Browse our FAQs page for insights and answers to your most pressing questions—let us help you find your perfect home!",
  "property_floorplans_blurb": "<p>At our amazing community, you will find comfortably designed and spacious floor plans of one, two, and three-bedroom apartments for rent with bright open spaces and thoughtful details and <a href=\"/amenities/\">amenities</a> to enhance each moment of your life. Make sure you bring your four-legged friends along; they are welcome and will love their lives here!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Traditions at Westmoore in Oklahoma City, comfort meets convenience with spacious two and three-bedroom floor plans designed for your lifestyle. Enjoy exceptional amenities like two sparkling pools, a state-of-the-art 24-hour fitness center, and a cozy gas fire pit. Dive into our interactive community map to find your new home!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Traditions at Westmoore in Oklahoma City, our spacious two- and three-bedroom floor plans are designed for modern living. Share the joy of community—refer a friend today and cultivate connections that matter. Great friends make great neighbors, enriching your experience at home amid beautiful surroundings. ",
  "property_residentaccess_blurb": "Welcome to Traditions at Westmoore in vibrant Oklahoma City, where our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Enhance your living experience by accessing the resident portal—pay rent, schedule maintenance, and stay connected effortlessly. Your home awaits!",
  "property_reviews_blurb": "At Traditions at Westmoore in Oklahoma City, residents celebrate a vibrant community where neighbors connect and enjoy spacious, well-maintained homes. With a dedicated staff committed to exceptional service, it’s no wonder our residents say, “Customer service makes this place a 10/10.” See what our residents have to say about living at our community!",
  "property_created_at": "1752257094747",
  "property_scheduletour_blurb": "At Traditions at Westmoore in Oklahoma City, our thoughtfully designed two and three-bedroom floor plans cater to your lifestyle needs. Experience comfort and community in a vibrant setting. Schedule a tour today and hear firsthand from our residents about what makes living here truly special!",
  "property_thankyou_blurb": "Thank you for reaching out to Traditions at Westmoore in Oklahoma City, OK! Our spacious two and three-bedroom floor plans await your personal touch. We’ll be in touch soon to help you create the perfect home in our vibrant community. Your new adventure starts here—stay tuned!",
  "property_virtualtours_blurb": "<p>At Traditions at Westmoore, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Traditions at Westmoore",
  "property_seo_title_home": "Traditions at Westmoore | Apartments in Oklahoma City, OK",
  "property_seo_description_home": "Experience modern living at Traditions at Westmoore in Oklahoma City, where comfort meets convenience. Choose from stylish two and three-bedroom floor plans, complete with upscale amenities like 24-hour fitness and a gated community. Enjoy community gas grills, sparkling pools, and a dog park, all designed for your lifestyle. Whether it's a cozy night by the gas fire pit or a productive day at our business center, you'll feel right at home. Ready to elevate your living experience? Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 2 - 3 Apartments in Oklahoma City, OK",
  "property_seo_description_floorplans": "Uncover the ideal living space at Traditions at Westmoore in Oklahoma City! With spacious two and three-bedroom floor plans designed for comfort and style, your dream apartment awaits. Browse our selection of unique layouts and envision your future home today!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Traditions at Westmoore in Oklahoma City, where comfort meets convenience. Delight in our spacious two and three-bedroom floor plans, complemented by a wealth of amenities including sparkling pools, a state-of-the-art fitness center, and scenic dog parks. Unwind with friends around the gas fire pit or host gatherings in our stylish clubroom. With 24/7 management and maintenance, ample parking, and direct access to the Vulcan Trail, your ideal lifestyle awaits. Step into a community where every detail enhances your living experience—check out our exceptional offerings today!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, OK",
  "property_seo_description_gallery": "\"Imagine a lifestyle of comfort and convenience at Traditions at Westmoore in Oklahoma City, OK! Our vibrant community features stunning two and three-bedroom floor plans, alongside top-tier amenities like gas grills, two sparkling pools, and a fully-equipped 24-hour fitness center. Enjoy direct access to the Vulcan Trail, relax in the clubroom, or let your furry friends play in the dog park. With 24/7 management and maintenance, your peace of mind is our priority. Picture yourself living here!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Traditions at Westmoore Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Traditions at Westmoore in Oklahoma City, where modern living meets comfort. Our diverse floor plans include spacious two and three-bedroom apartments designed to fit your lifestyle. Immerse yourself in a virtual tour today and envision your future in this vibrant community nestled in the heart of Oklahoma. ",
  "property_seo_title_interactivemap": "Interactive Map | Traditions at Westmoore Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Traditions at Westmoore in Oklahoma City, where modern living meets exceptional amenities. Choose from spacious two and three-bedroom floor plans, and indulge in community perks like sparkling pools, a state-of-the-art fitness center, and scenic direct access to the Vulcan trail. Enjoy peace of mind with 24/7 maintenance, covered parking, and a vibrant clubhouse with gas grills and a fire pit for those relaxed evenings. Navigate our interactive community map to discover availability and pricing today—your dream apartment awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, OK",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle at Traditions at Westmoore in Oklahoma City, OK. Nestled in a dynamic neighborhood, our community offers not just two and three-bedroom floor plans, but also a rich tapestry of local favorites just steps away from your door. Dive into nearby parks, dining, and entertainment options that make this area truly special. Uncover the charm of our surroundings and find your new home today!",
  "property_seo_title_contact": "Contact Us | Traditions at Westmoore",
  "property_seo_description_contact": "Looking for your ideal home in Oklahoma City? At Traditions at Westmoore, we offer spacious two and three-bedroom floor plans designed for comfort and style. Our team is here to assist with any inquiries or provide guidance as you embark on your apartment search. Don’t hesitate—reach out to our leasing experts today with your questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, OK",
  "property_seo_description_faqs": "\"Unearth the lifestyle you've been searching for at Traditions at Westmoore in Oklahoma City, where luxury meets convenience. With spacious two and three-bedroom floor plans, a state-of-the-art 24-hour fitness center, and vibrant community amenities like gas grills, a dog park, sparkling pools, and a clubhouse, our gated community caters to all your needs. Have questions? Browse our FAQs page for answers and imagine your new home with endless perks designed for comfort and enjoyment.\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, OK",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at Traditions at Westmoore in Oklahoma City, where comfort meets convenience. Choose from spacious two and three-bedroom floor plans, and enjoy amenities like two sparkling pools, a state-of-the-art fitness center, and a welcoming clubhouse. Whether relaxing by the gas fire pit, grilling with friends, or taking your furry friend to the dog park, every day brings something new. With 24/7 on-call maintenance and gated community access, peace of mind is paramount. See what our residents love most about calling Traditions at Westmoore home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, OK",
  "property_seo_description_applynow": "Experience the perfect blend of comfort and convenience at Traditions at Westmoore in Oklahoma City. Choose from spacious two and three-bedroom floor plans with upgraded features, and enjoy resort-style amenities including two sparkling pools, a fully-equipped 24-hour fitness center, and meticulously maintained dog parks. With 24/7 management and maintenance, well-lit car wash stations, and a welcoming clubroom, every detail is designed to enhance your lifestyle. Your new home awaits—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Traditions at Westmoore",
  "property_seo_description_residentaccess": "\"Welcome to Traditions at Westmoore in Oklahoma City! Elevate your living experience—log in to your resident portal to effortlessly manage rent payments, request maintenance, and access community resources. Your seamless lifestyle starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | Traditions at Westmoore",
  "property_seo_description_referafriend": "\"Share the love of living at Traditions at Westmoore in Oklahoma City! Refer a friend today and help them find their new home in our vibrant community. Great friends make great neighbors!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Traditions at Westmoore",
  "property_seo_description_scheduletour": "\"Step into your future at Traditions at Westmoore in Oklahoma City! Experience a vibrant community where modern living meets comfort. Schedule a tour today to find your perfect apartment and enjoy the lifestyle you deserve!\"",
  "property_seo_title_privacy": "Privacy Policy | Traditions at Westmoore",
  "property_seo_description_privacy": "At Traditions at Westmoore in Oklahoma City, your data privacy is our priority. Delve into our transparent practices and learn how we safeguard your information while you enjoy a community designed for comfort and connection. View our privacy policy to understand how we protect what matters to you.",
  "property_seo_title_accessibility": "Website Accessibility | Traditions at Westmoore",
  "property_seo_description_accessibility": "\"At Traditions at Westmoore in Oklahoma City, we’re committed to creating an accessible living environment for everyone. Our accessibility statement outlines our pledge to digital inclusion and ensuring all residents experience a seamless online journey. Join us in fostering a community that values inclusivity and comfort.\"",
  "property_seo_title_sitemap": "Sitemap | Traditions at Westmoore",
  "property_seo_description_sitemap": "\"Navigate your way to your perfect home at Traditions at Westmoore in Oklahoma City. Our comprehensive sitemap gives you a clear pathway to amenities, floor plans, and community features. Uncover the details that make Westmoore your ideal living choice!\"",
  "property_seo_title_thankyou": "Thank You | Traditions at Westmoore",
  "property_seo_description_thankyou": "Thank you for reaching out to Traditions at Westmoore in Oklahoma City! Your request is in good hands. Our dedicated team is eager to assist you in finding your ideal home. Stay tuned for a personalized response soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293557971",
  "amenities": [
    {
      "id": "ec_d64d31fb18b34d4ea92a1769",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "Listed under Community Amenities exactly as “24-Hour Emergency Maintenance.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fab3f1fe5b745149bae990cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "Present exactly as “Bark Park.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d5ecf891400132f0f41213d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Community Grilling Areas",
      "amount": "false",
      "description": "Present exactly as “Community Grilling Areas.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef5aa1c049ef033e35b64f61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Covered Parking (Rentable)",
      "amount": "false",
      "description": "Present exactly as “Covered Parking (Rentable).”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cad81bb945b13863525e8cc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Present exactly as “Fitness Center.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91c9898d22c2ce11668a0dfe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Free Clubhouse Wi‑Fi",
      "amount": "false",
      "description": "Listed exactly as “Free Clubhouse Wi‑Fi.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_161858a709e44c599e256dcb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Free Coffee Bar",
      "amount": "false",
      "description": "Listed exactly as “Free Coffee Bar.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_baf9f1c3545fde34170fc1ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Garage",
      "amount": "false",
      "description": "Present exactly as “Garage.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48db83a91b012f4d194e8a4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Present exactly as “Online Payments Available.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fca440e65804f25077c5d75",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "Present exactly as “Resident Events.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ed247f75f2be767c5d209bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Sparkling Swimming Pool",
      "amount": "false",
      "description": "Present exactly as “Sparkling Swimming Pool.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8c4a008963a0732f7755579",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Units (Rentable)",
      "amount": "false",
      "description": "Present exactly as “Storage Units (Rentable).”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3c17d4bb182db3c9c79ff28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "Present exactly as “Valet Trash Service.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8861448937ca2880c3143113",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Walking Distance to Local Restaurants and Shops",
      "amount": "false",
      "description": "Present exactly as “Walking Distance to Local Restaurants and Shops.”",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f7fa775fd2590163063ef26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Balconies and Patios",
      "amount": "false",
      "description": "Present exactly as “Balconies and Patios.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_442d04a3e7e7d398ee66fa97",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "Present exactly as “Breakfast Bar.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d624c0add13372f57f05db2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Extra Storage*",
      "amount": "false",
      "description": "Present exactly as “Extra Storage*.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2043bbbb1d9913e49d99470",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "Present exactly as “Microwave.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd39af527769b1d987842adc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Open Floorplans",
      "amount": "false",
      "description": "Present exactly as “Open Floorplans.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f83dc7713a8ad04582a9777f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "Present exactly as “Plush Carpeting.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d159230f635cfb4d64e6fca8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "Present exactly as “Walk‑in Closets.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c4b9b730540f58b74b20661",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer in Home",
      "amount": "false",
      "description": "Present exactly as “Washer and Dryer in Home.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_077b9c9680269b39a113e011",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑style Flooring",
      "amount": "false",
      "description": "Present exactly as “Wood‑style Flooring.”",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6c0decd1-af05-40c1-bc7b-5f58a5009f30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-494d-746c-8d63-73fdf81c39f3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas outside a brick building.",
        "public_id": "019e84e4-494d-746c-8d63-73fdf81c39f3",
        "storage_key": "property/6737460151191770/019e84e4-494d-746c-8d63-73fdf81c39f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas for a perfect day of leisure.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas outside a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_794fc781-c38b-4ec1-a84c-b149e2bbb63a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-4946-733e-8c61-bb7ced09cb57.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with orange couches and a fire pit next to a swimming pool.",
        "public_id": "019e84e4-4946-733e-8c61-bb7ced09cb57",
        "storage_key": "property/6737460151191770/019e84e4-4946-733e-8c61-bb7ced09cb57.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, complete with comfortable seating, a fire pit, and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with orange couches and a fire pit next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33502067-bf16-41ee-be47-c40c6bbefa05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-2eb7-75d3-a9ed-1e3bf32c6bf7.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with light wood cabinets, granite countertops, black appliances, and a round dining table with four orange chairs.",
        "public_id": "01a09198-2eb7-75d3-a9ed-1e3bf32c6bf7",
        "storage_key": "property/6737460151191770/01a09198-2eb7-75d3-a9ed-1e3bf32c6bf7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen and dining space featuring modern appliances, ample counter space, and a stylish dining set perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen and dining area with light wood cabinets, granite countertops, black appliances, and a round dining table with four orange chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f251844a-d4b9-4ebd-b142-b3075c5170df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-2b0b-7389-89cf-3ac841a5122c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, black appliances, and granite countertops.",
        "public_id": "01a09198-2b0b-7389-89cf-3ac841a5122c",
        "storage_key": "property/6737460151191770/01a09198-2b0b-7389-89cf-3ac841a5122c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring light wood cabinetry, sleek black appliances including a microwave and refrigerator, and durable granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d750b402-874a-4da4-a6a2-d0e735f673a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-0ef2-74ff-a56e-dffea211ddb7.webp",
      "image_media": {
        "alt_text": "Open concept living area with a kitchen and bedroom visible.",
        "public_id": "01a09198-0ef2-74ff-a56e-dffea211ddb7",
        "storage_key": "property/6737460151191770/01a09198-0ef2-74ff-a56e-dffea211ddb7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern open-concept living space featuring a full kitchen, dining area, and a glimpse into the private bedroom.",
      "link": "",
      "alt_text": "Open concept living area with a kitchen and bedroom visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1e6fcdb-dc38-4de1-ba15-60f34e190882",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-26f9-7296-b7a4-2d47330e5217.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a sofa, accent chairs, and dining table.",
        "public_id": "01a09198-26f9-7296-b7a4-2d47330e5217",
        "storage_key": "property/6737460151191770/01a09198-26f9-7296-b7a4-2d47330e5217.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish living and dining space featuring a comfortable sofa, elegant chairs, and a contemporary dining set, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living and dining area with a sofa, accent chairs, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dcbd3949-821f-4213-859c-333b122b08dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-0f2e-7757-b1de-84b7df21a1e8.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, leather accent chair, and decorative tables.",
        "public_id": "01a09198-0f2e-7757-b1de-84b7df21a1e8",
        "storage_key": "property/6737460151191770/01a09198-0f2e-7757-b1de-84b7df21a1e8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush white sofa, elegant leather chair, and unique woven side tables. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a white sofa, leather accent chair, and decorative tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d85f55c2-e4c9-4764-aadb-d7b51988d83c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-0f69-71a3-b354-415aa2ae59fe.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, gray headboard, white linens, and decorative pillows.",
        "public_id": "01a09198-0f69-71a3-b354-415aa2ae59fe",
        "storage_key": "property/6737460151191770/01a09198-0f69-71a3-b354-415aa2ae59fe.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A stylish and comfortable bedroom featuring a queen-size bed, complemented by soft gray carpeting and a neutral color palette for a serene atmosphere.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, gray headboard, white linens, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_026584ec-d6b9-467d-b4da-34f27829698d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-0ebf-724b-8204-6e0b6ed133ec.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with sofas, chairs, and a coffee table in a communal lounge space.",
        "public_id": "01a09198-0ebf-724b-8204-6e0b6ed133ec",
        "storage_key": "property/6737460151191770/01a09198-0ebf-724b-8204-6e0b6ed133ec.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring comfortable seating, a coffee table, and a work area with computers.",
      "link": "",
      "alt_text": "Comfortable seating area with sofas, chairs, and a coffee table in a communal lounge space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e863b076-20c2-45d5-a24e-c3fcef4ab2e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-147e-72fc-8562-d5c91ccfcddf.webp",
      "image_media": {
        "alt_text": "Communal dining area with a round wooden table, upholstered chairs, and a small kitchenette.",
        "public_id": "01a09198-147e-72fc-8562-d5c91ccfcddf",
        "storage_key": "property/6737460151191770/01a09198-147e-72fc-8562-d5c91ccfcddf.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy gatherings in our communal dining area, complete with a well-equipped kitchenette and comfortable seating for residents.",
      "link": "",
      "alt_text": "Communal dining area with a round wooden table, upholstered chairs, and a small kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_111420e3-40ad-4db4-8cd5-392ea94ec4b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-248c-7148-ab65-866a12f32c5e.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "01a09198-248c-7148-ab65-866a12f32c5e",
        "storage_key": "property/6737460151191770/01a09198-248c-7148-ab65-866a12f32c5e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a granite countertop vanity, a toilet, and a shower/tub combination with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43280fdc-f3b5-48eb-8668-327f9542722d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/01a09198-0f27-746b-8746-2f16cb74e07d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, and dumbbells.",
        "public_id": "01a09198-0f27-746b-8746-2f16cb74e07d",
        "storage_key": "property/6737460151191770/01a09198-0f27-746b-8746-2f16cb74e07d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout, including cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stationary bikes, weight machines, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_937815c7-c432-4a2c-b8f7-72131b2e05e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-470d-756a-85e4-78e0cd41d06f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "019e84e4-470d-756a-85e4-78e0cd41d06f",
        "storage_key": "property/6737460151191770/019e84e4-470d-756a-85e4-78e0cd41d06f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom, featuring a spacious vanity with granite countertops, a convenient toilet, and a relaxing bathtub with shower.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a42b0a51-5350-42a8-9f5c-bb0d5ff03a9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-32ee-7695-b047-a70f90f80aa5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a fenced dog park area in the foreground.",
        "public_id": "019e84e4-32ee-7695-b047-a70f90f80aa5",
        "storage_key": "property/6737460151191770/019e84e4-32ee-7695-b047-a70f90f80aa5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious apartment community featuring a dedicated dog park for your furry friends, perfect for outdoor recreation.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a fenced dog park area in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01a06f6e-7e06-4653-823f-4c47839c164d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-32b1-777b-a833-b74b31231a20.webp",
      "image_media": {
        "alt_text": "Empty bedroom with plush carpet, a ceiling fan, and two windows with blinds.",
        "public_id": "019e84e4-32b1-777b-a833-b74b31231a20",
        "storage_key": "property/6737460151191770/019e84e4-32b1-777b-a833-b74b31231a20.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a modern ceiling fan, and ample natural light from two large windows with blinds.",
      "link": "",
      "alt_text": "Empty bedroom with plush carpet, a ceiling fan, and two windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_258aa25b-1f1c-4f8b-ab07-f46a2dffada6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-315d-769b-b039-af566e254d13.webp",
      "image_media": {
        "alt_text": "Spacious living area with a modern kitchen island and ample cabinet space.",
        "public_id": "019e84e4-315d-769b-b039-af566e254d13",
        "storage_key": "property/6737460151191770/019e84e4-315d-769b-b039-af566e254d13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "An open-concept living area seamlessly transitions into a contemporary kitchen, featuring a central island, sleek countertops, and abundant cabinetry.",
      "link": "",
      "alt_text": "Spacious living area with a modern kitchen island and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0551eff-9025-4d12-a5d9-808b3144aaf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-33ae-778f-9171-c6994f17deb8.webp",
      "image_media": {
        "alt_text": "Exterior view of a garage and carport with apartments in the background.",
        "public_id": "019e84e4-33ae-778f-9171-c6994f17deb8",
        "storage_key": "property/6737460151191770/019e84e4-33ae-778f-9171-c6994f17deb8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Covered parking and individual garages available for residents, complementing the apartment buildings.",
      "link": "",
      "alt_text": "Exterior view of a garage and carport with apartments in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5ee8c06-8b01-467b-9d80-8de75bc67594",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-31ec-7625-8ed1-6227ff5cf524.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with garages and light post.",
        "public_id": "019e84e4-31ec-7625-8ed1-6227ff5cf524",
        "storage_key": "property/6737460151191770/019e84e4-31ec-7625-8ed1-6227ff5cf524.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Townhome-style apartments feature private garages with direct access, providing convenience and security for residents.",
      "link": "",
      "alt_text": "Exterior view of apartment building with garages and light post.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0469e06-6a5d-477a-9522-7c840409124b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e84e4-319d-725b-ae4e-a2a043ad481c.webp",
      "image_media": {
        "alt_text": "Empty dining area with wood-look flooring and a pendant light.",
        "public_id": "019e84e4-319d-725b-ae4e-a2a043ad481c",
        "storage_key": "property/6737460151191770/019e84e4-319d-725b-ae4e-a2a043ad481c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience a spacious dining area, perfect for hosting guests, with modern finishes and ample lighting.",
      "link": "",
      "alt_text": "Empty dining area with wood-look flooring and a pendant light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d56078d4-3629-4833-bdbf-cf3883048e1a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Sugar Llamas Westmoore",
      "poi_type": "Restaurants",
      "poi_address": "12501 S Western Ave Suite E, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Easygoing ice cream counter, also serving doughnuts, coffee and frozen llamanade.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-a74a-769c-8ed8-55062b76f1b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-a74a-769c-8ed8-55062b76f1b0",
        "storage_key": "property/6737460151191770/019e1e22-a74a-769c-8ed8-55062b76f1b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sugarllamas.com/westmoore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10350091864360209214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugar-llamas-westmoore",
      "poi_latitude": "35.3446819",
      "poi_longitude": "-97.5305931",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-237-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ74xNexQTsocRPsvZp7bpoo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_b9fec56d-413f-4a54-84bc-5da675ea6ba6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Madison’s Cafe- American Diner and Mediterranean Food",
      "poi_type": "Restaurants",
      "poi_address": "12501 S Western Ave Suite A, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Casual eatery dishing up American and Mediterranean dishes for breakfast, lunch, and dinner.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-a4dc-74f9-a1f1-2efc106b2c63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-a4dc-74f9-a1f1-2efc106b2c63",
        "storage_key": "property/6737460151191770/019e1e22-a4dc-74f9-a1f1-2efc106b2c63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://online.skytab.com/5863a86a9c57ff979aa93c2dad4bcaad",
      "poi_directions_map_url": "https://maps.google.com/?cid=1538292949970023154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madisons-cafe--american-diner-and-mediterranean-food",
      "poi_latitude": "35.3447988",
      "poi_longitude": "-97.5306897",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-676-5678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRyVT01sTsocR8nJzq0kdWRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8d47104b-a531-4b7d-9b52-d92cb0743612",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Dale's BBQ House",
      "poi_type": "Restaurants",
      "poi_address": "11801 S Western Ave suite b, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Casual barbecue joint dishing up ribs, turkey, brisket, and sides in a cozy space with a kids' menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-a8b9-710a-888d-0aa30d953b0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-a8b9-710a-888d-0aa30d953b0a",
        "storage_key": "property/6737460151191770/019e1e22-a8b9-710a-888d-0aa30d953b0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2846405905172668439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dales-bbq-house",
      "poi_latitude": "35.3493319",
      "poi_longitude": "-97.5313039",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-692-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgRdGOlwTsocRFyBkABd3gCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_bcda8f81-e7d9-41f7-8fdc-14be437a216e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Eagle One Pizza",
      "poi_type": "Restaurants",
      "poi_address": "11613 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Snug, order-at-the-counter shopping-center pizzeria also offering calzones, gyros & wings.",
      "poi_long_description": "Snug, order-at-the-counter shopping-center pizzeria also offering calzones, gyros & wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-acbf-71a4-b0a2-41075f9c542b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-acbf-71a4-b0a2-41075f9c542b",
        "storage_key": "property/6737460151191770/019e1e22-acbf-71a4-b0a2-41075f9c542b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.eagleonepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8304784553041196647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eagle-one-pizza",
      "poi_latitude": "35.35143130000001",
      "poi_longitude": "-97.5308869",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-703-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp6qAdl4TsocRZ_Yr5IyFQHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_11f0f897-0f0f-487f-887b-af78bac2ca34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Cocina El Girasol",
      "poi_type": "Restaurants",
      "poi_address": "11641 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Casual restaurant serving a range of classic Mexican eats, plus burritos and pupusas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-a3a9-773f-a856-86cf05e526a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-a3a9-773f-a856-86cf05e526a2",
        "storage_key": "property/6737460151191770/019e1e22-a3a9-773f-a856-86cf05e526a2.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15897738617588468622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cocina-el-girasol",
      "poi_latitude": "35.351074",
      "poi_longitude": "-97.53149150000002",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-676-5376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WTLxosTsocRjste-QodoNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_13607f9b-150d-44e0-a7e5-15ff2c1e8ec2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Soda Pop's #1",
      "poi_type": "Restaurants",
      "poi_address": "1020 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Quirky pit stop serving homestyle dishes amid retro soda pop bottles & advertising memorabilia.",
      "poi_long_description": "Quirky pit stop serving homestyle dishes amid retro soda pop bottles & advertising memorabilia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-aa05-72be-9b6b-c515442665f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-aa05-72be-9b6b-c515442665f5",
        "storage_key": "property/6737460151191770/019e1e22-aa05-72be-9b6b-c515442665f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sodapopsokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9809653715141540237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soda-pops-1",
      "poi_latitude": "35.3483652",
      "poi_longitude": "-97.5308141",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-692-7677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7QrID1wTsocRjTmahBTkIog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_dc4f0dfd-50f6-4db6-abcd-cb07c2dfa59c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Dan's Ol' Time Diner",
      "poi_type": "Restaurants",
      "poi_address": "10633 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Relaxed hamburger stop featuring self-serve condiments, plus an array of fried fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-a74e-72ff-9cac-bcfa89ced0e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-a74e-72ff-9cac-bcfa89ced0e8",
        "storage_key": "property/6737460151191770/019e1e22-a74e-72ff-9cac-bcfa89ced0e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15060359719182768222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dans-ol-time-diner",
      "poi_latitude": "35.3617148",
      "poi_longitude": "-97.5304111",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-634-8806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUd14J4QTsocRXph9E18lAdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2f361a6a-93c6-4063-80f1-c7594b65914d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Lumpy's Sports Grill South",
      "poi_type": "Restaurants",
      "poi_address": "10601 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Casual bar featuring karaoke and dart boards, plus a menu of pizzas, burgers and pub grub favorites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-a3c7-7759-8544-716e169a91ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-a3c7-7759-8544-716e169a91ae",
        "storage_key": "property/6737460151191770/019e1e22-a3c7-7759-8544-716e169a91ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lumpyssportsgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4817275590064120526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lumpys-sports-grill-south",
      "poi_latitude": "35.3621154",
      "poi_longitude": "-97.5309828",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-735-9559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070a-75a9-a7a4-05d433ca01d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070a-75a9-a7a4-05d433ca01d0",
        "storage_key": "property/6737460151191770/019e1e23-070a-75a9-a7a4-05d433ca01d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdyZVkGQTsocRzqLuSqBm2kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_156197c1-e6e3-4e7a-9a04-207881aaeaf3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Ted's Café Escondido",
      "poi_type": "Restaurants",
      "poi_address": "8324 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Local chain serving traditional Mexican fare in a relaxed space with traditional touches.",
      "poi_long_description": "Local chain serving traditional Mexican fare in a relaxed space with traditional touches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ac4e-72c0-8d47-1a7d5408f35f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ac4e-72c0-8d47-1a7d5408f35f",
        "storage_key": "property/6737460151191770/019e1e22-ac4e-72c0-8d47-1a7d5408f35f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tedscafe.com/teds-locations/south-okc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5626345906635619306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teds-caf-escondido",
      "poi_latitude": "35.3827041",
      "poi_longitude": "-97.5293852",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-635-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXDNj4YTsocR6jt93MrLFE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ab0b8762-222a-4c78-9618-08376a4c069b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "El Mexicano #3",
      "poi_type": "Restaurants",
      "poi_address": "8624 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Taco truck and taqueria serving burritos, tortas and other classic Mexican eats, plus ice-cold drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-a485-7172-b9a6-8fe87cc980a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-a485-7172-b9a6-8fe87cc980a6",
        "storage_key": "property/6737460151191770/019e1e22-a485-7172-b9a6-8fe87cc980a6.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15334509678771662239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-mexicano-3",
      "poi_latitude": "35.3795295",
      "poi_longitude": "-97.5296108",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-885-6134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wmie-YTsocRn235n04fz9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_aab70a63-23ad-4034-8641-bea0998ba2a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "K.World Chick",
      "poi_type": "Restaurants",
      "poi_address": "14900 S Western Ave Suite 170, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Casual, trendy place dishing up Korean fare such as ramen, crispy wings, kimbap and bulgogi bowls.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-af20-722d-9b77-774d2b7a1c75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-af20-722d-9b77-774d2b7a1c75",
        "storage_key": "property/6737460151191770/019e1e22-af20-722d-9b77-774d2b7a1c75.webp",
        "width": 1280,
        "height": 991
      },
      "poi_business_url": "https://kworldchick.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11021770757840957852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kworld-chick",
      "poi_latitude": "35.32049",
      "poi_longitude": "-97.5294535",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-237-3987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLfcP0i5tsocRnPHlwBsy9Zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_22d7de74-8473-4a5c-88a4-00e27f67cd1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Industry Gastro Lounge Moore",
      "poi_type": "Restaurants",
      "poi_address": "1201 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "Comfort-food options ranging from rotisserie chicken to burgers dished up in a relaxed venue.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-b151-72eb-ae8b-c61cd087f870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-b151-72eb-ae8b-c61cd087f870",
        "storage_key": "property/6737460151191770/019e1e22-b151-72eb-ae8b-c61cd087f870.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.industrygastro.com/?utm_source=Google&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=9667972930122465710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "industry-gastro-lounge-moore",
      "poi_latitude": "35.3269987",
      "poi_longitude": "-97.4912129",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-676-8211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ZUcioBrsocRrsEKJiiKK4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_38fee0b0-b94b-42d7-8fcf-a41816cb7ff0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "The Garage Burgers & Beer Moore",
      "poi_type": "Restaurants",
      "poi_address": "2060 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "Garage-themed eatery featuring classic burgers, plus tacos, sandwiches and brews.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-afe7-735b-9345-145b35378799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-afe7-735b-9345-145b35378799",
        "storage_key": "property/6737460151191770/019e1e22-afe7-735b-9345-145b35378799.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/the-garage-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5392685646770422881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-garage-burgers--beer-moore",
      "poi_latitude": "35.3185737",
      "poi_longitude": "-97.4864899",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-759-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ68dZQSRrsocRYUQZKQar1ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_4f4a3ac0-32f3-45ed-af5e-3330c31daeed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Van's Pig Stands",
      "poi_type": "Restaurants",
      "poi_address": "1991 Tower Dr, Moore, OK 73160, USA",
      "poi_short_description": "Local BBQ chain serving ribs, sandwiches & Southern sides in a casual setting.",
      "poi_long_description": "Local BBQ chain serving ribs, sandwiches & Southern sides in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-b03a-71a8-9629-ce72433abdb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-b03a-71a8-9629-ce72433abdb6",
        "storage_key": "property/6737460151191770/019e1e22-b03a-71a8-9629-ce72433abdb6.webp",
        "width": 480,
        "height": 470
      },
      "poi_business_url": "https://www.pigstands.com/?y_source=1_MjAxNjAzNjYwNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7880832428601618933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vans-pig-stands",
      "poi_latitude": "35.3203706",
      "poi_longitude": "-97.4832394",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-703-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-D_Nc0UsocR9bEt4VZXXm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_da94abad-8a73-4170-b972-f72de4b30a96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "12000 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-b288-77f9-a317-1cfb9910cc79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-b288-77f9-a317-1cfb9910cc79",
        "storage_key": "property/6737460151191770/019e1e22-b288-77f9-a317-1cfb9910cc79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ok7-eleven.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17635326120838126498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "35.348378",
      "poi_longitude": "-97.5293358",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-691-2867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-06f5-723a-8242-1a72a7364c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-06f5-723a-8242-1a72a7364c89",
        "storage_key": "property/6737460151191770/019e1e23-06f5-723a-8242-1a72a7364c89.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJNRvDr14TsocRolu5wqtDvfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_3d98975d-e7bc-4415-84b1-0958dee1b6c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2100 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-b342-7368-8dd8-666ad2c88ad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-b342-7368-8dd8-666ad2c88ad3",
        "storage_key": "property/6737460151191770/019e1e22-b342-7368-8dd8-666ad2c88ad3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/oklahoma-city-ok-pharmacies/2100-sw-119th-st-oklahoma-city-ok-73170/storeid=6236?WT.mc_id=LS_GOOGLE_RX_6236",
      "poi_directions_map_url": "https://maps.google.com/?cid=4491889118604000540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3482873",
      "poi_longitude": "-97.5481756",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-691-1041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070c-7399-a94d-d1ec9650cd2c",
        "storage_key": "property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVvVFj8TsocRHH3VtFplVj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3ab70bfe-4876-4509-bfe3-1770c6aac43d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1640 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-b677-717e-a60d-3db6439f8b98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-b677-717e-a60d-3db6439f8b98",
        "storage_key": "property/6737460151191770/019e1e22-b677-717e-a60d-3db6439f8b98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1640+sw+119th+st-oklahoma+city-ok-73170/id=6109",
      "poi_directions_map_url": "https://maps.google.com/?cid=13855057464725081611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.3483377",
      "poi_longitude": "-97.5470572",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-692-3432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdV2jkkATsocRCw6QX1sNR8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_51879406-3c04-4055-958c-6a78f989caa9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "World Fresh International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10700 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Produce and meat purveyor for Asian ingredients, baked goods and ethnic eats, plus tea.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-d073-7264-a6a4-8796dd7ffdf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-d073-7264-a6a4-8796dd7ffdf7",
        "storage_key": "property/6737460151191770/019e1e20-d073-7264-a6a4-8796dd7ffdf7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.worldfreshmarketokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15266477169668212953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-fresh-international-market",
      "poi_latitude": "35.3612615",
      "poi_longitude": "-97.5467944",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-349-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-063b-717d-887b-03912590086e",
        "storage_key": "property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVfSKFoTsocR2UivvRls3dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_067e76a8-986a-433e-981b-23eac5d87c96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10601 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Chain grocery outlet supplying produce, baked goods, and sushi, plus self-checkout.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-cf7e-7502-b352-d2eafd2b295d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-cf7e-7502-b352-d2eafd2b295d",
        "storage_key": "property/6737460151191770/019e1e20-cf7e-7502-b352-d2eafd2b295d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4018949886565178595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.3622151",
      "poi_longitude": "-97.5680332",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-814-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-063b-717d-887b-03912590086e",
        "storage_key": "property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfJhuAITsocR41zQ5qAtxjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_26db9f32-0899-4ebd-8a26-3611b997de7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "911 SW 104th St, Oklahoma City, OK 73139",
      "poi_short_description": "Supermarket featuring some items not found at other locations, plus self-checkout lanes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-b800-7237-a21b-e78be5a2e1cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-b800-7237-a21b-e78be5a2e1cd",
        "storage_key": "property/6737460151191770/019e1e22-b800-7237-a21b-e78be5a2e1cd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/5323-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=135545776876200462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.3329713",
      "poi_longitude": "-97.5129923",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-300-6419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-063b-717d-887b-03912590086e",
        "storage_key": "property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3317rIUsocRDqKCeSqO4QE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9cf3fe07-1fba-49e8-b5f7-cdff619c97e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3301 SW 104th St, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Clean department store selling groceries, furniture and electronics alongside clothing and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-bc3d-717e-babe-74d969ead492.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-bc3d-717e-babe-74d969ead492",
        "storage_key": "property/6737460151191770/019e1e22-bc3d-717e-babe-74d969ead492.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/7326-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8958961904860996264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.3655059",
      "poi_longitude": "-97.5767452",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-300-6584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060d-73ac-9fc6-0542f94afd39",
        "storage_key": "property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN8dfN_oSsocRqCJ_x2KgVHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_715e38e7-ce16-4596-8492-dd3b44121a6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Eaglet Specialty Pharmacy - Oklahoma Branch",
      "poi_type": "Shopping & Retail",
      "poi_address": "2209 SW 104th St Suite E, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-bc8b-737c-9dbf-03b7afb8ca54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-bc8b-737c-9dbf-03b7afb8ca54",
        "storage_key": "property/6737460151191770/019e1e22-bc8b-737c-9dbf-03b7afb8ca54.webp",
        "width": 368,
        "height": 444
      },
      "poi_business_url": "http://www.eagletspecialtypharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=375234072920223812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eaglet-specialty-pharmacy---oklahoma-branch",
      "poi_latitude": "35.3636806",
      "poi_longitude": "-97.550409",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-676-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070c-7399-a94d-d1ec9650cd2c",
        "storage_key": "property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7v2qIQTsocRRHAIuGYZNQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_28341fef-4222-49bd-851d-9ca57ce2c1af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "OnCue",
      "poi_type": "Shopping & Retail",
      "poi_address": "3700 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Gas station featuring a grill menu, plus breakfast fare and coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-bcc9-706d-924c-4d0cc156dd81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-bcc9-706d-924c-4d0cc156dd81",
        "storage_key": "property/6737460151191770/019e1e22-bcc9-706d-924c-4d0cc156dd81.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oncue.com/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12442567510633136223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oncue",
      "poi_latitude": "35.347817",
      "poi_longitude": "-97.5838526",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-691-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-06f5-723a-8242-1a72a7364c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-06f5-723a-8242-1a72a7364c89",
        "storage_key": "property/6737460151191770/019e1e23-06f5-723a-8242-1a72a7364c89.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJLz2lasISsocRX8AaNTrhrKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_ef6c163a-a9b0-486c-8d69-2b68465ae545",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Westmoore High School",
      "poi_type": "Education",
      "poi_address": "12613 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-be01-71b9-8a2d-68236ae8d15b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-be01-71b9-8a2d-68236ae8d15b",
        "storage_key": "property/6737460151191770/019e1e22-be01-71b9-8a2d-68236ae8d15b.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://westmoorehs.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9023050078341389623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westmoore-high-school",
      "poi_latitude": "35.3424114",
      "poi_longitude": "-97.5342346",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-735-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvaTAo1oTsocRN10Zdj1QOH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_95c2df2b-44d6-43ec-8a62-e270cd27efef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Brink Junior High School",
      "poi_type": "Education",
      "poi_address": "11420 S Western Ave, Moore, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://brinkjh.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15933095597142122373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brink-junior-high-school",
      "poi_latitude": "35.35359",
      "poi_longitude": "-97.5284473",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-735-4540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1-9WtGATsocRhR__Rwe6Hd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_dcf958e3-7e59-456d-8c67-669629ff2579",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Eastlake Elementary School",
      "poi_type": "Education",
      "poi_address": "1301 SW 134th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-beac-71a5-86e8-7d191ca94c4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-beac-71a5-86e8-7d191ca94c4a",
        "storage_key": "property/6737460151191770/019e1e22-beac-71a5-86e8-7d191ca94c4a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://eastlake.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9486846522344553594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastlake-elementary-school",
      "poi_latitude": "35.3352177",
      "poi_longitude": "-97.5392577",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-735-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQwwqZ1ITsocRejz_CqYMqIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_337b2357-b74f-497f-b8b3-f3d2be4532eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "South Lake Elementary School",
      "poi_type": "Education",
      "poi_address": "12701 S Portland Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c15b-75fc-9609-b112f6b37db1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c15b-75fc-9609-b112f6b37db1",
        "storage_key": "property/6737460151191770/019e1e22-c15b-75fc-9609-b112f6b37db1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mooreschools.com/Domain/3198",
      "poi_directions_map_url": "https://maps.google.com/?cid=6207265981395982429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-lake-elementary-school",
      "poi_latitude": "35.341805",
      "poi_longitude": "-97.5843888",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-735-4660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRXyjxsUSsocRXVh5x4WjJFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_926679b7-5756-448d-83f1-50771c09a90b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Earlywine Elementary School",
      "poi_type": "Education",
      "poi_address": "12800 S May Ave, Moore, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-bfd3-76e7-a7f6-86a50438cee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-bfd3-76e7-a7f6-86a50438cee2",
        "storage_key": "property/6737460151191770/019e1e22-bfd3-76e7-a7f6-86a50438cee2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://earlywine.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8308763345832692984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earlywine-elementary-school",
      "poi_latitude": "35.3406839",
      "poi_longitude": "-97.5643184",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-735-4150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ90bFMiYTsocR-Mwkxz2oTnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7f5251d3-eb3f-4b82-8e56-0b6d4cb0badb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Santa Fe Elementary School",
      "poi_type": "Education",
      "poi_address": "501 N Santa Fe Ave, Moore, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://santafe.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15922253951744765072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santa-fe-elementary-school",
      "poi_latitude": "35.3404583",
      "poi_longitude": "-97.5128524",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-735-4450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF4RCs7EUsocRkGxOAZw199w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b24f3710-2f17-4765-89b9-b880116ddbb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Wayland Bonds Elementary School",
      "poi_type": "Education",
      "poi_address": "14025 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c03f-718e-a1ac-463b38fa9544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c03f-718e-a1ac-463b38fa9544",
        "storage_key": "property/6737460151191770/019e1e22-c03f-718e-a1ac-463b38fa9544.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://waylandbonds.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3753529153017531385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayland-bonds-elementary-school",
      "poi_latitude": "35.3271542",
      "poi_longitude": "-97.5668694",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-735-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT09m1dRssocR-cuuq-A2FzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2dc2f8ba-3995-4be7-a691-3ba1b43c884f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "La Petite Academy on S. Western",
      "poi_type": "Education",
      "poi_address": "13200 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c2a8-77bf-ba71-1012c4fc780c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c2a8-77bf-ba71-1012c4fc780c",
        "storage_key": "property/6737460151191770/019e1e22-c2a8-77bf-ba71-1012c4fc780c.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/oklahoma-city-ok-7615/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7615",
      "poi_directions_map_url": "https://maps.google.com/?cid=5130346013736341315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-s-western",
      "poi_latitude": "35.3372591",
      "poi_longitude": "-97.5291576",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFZhXr1YTsocRQ4-Yi4SmMkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_fa4864b0-3d47-4e15-b3de-156409eb9ff2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Childtime on South Western",
      "poi_type": "Education",
      "poi_address": "10212 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c34c-7579-a241-ede517221837.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c34c-7579-a241-ede517221837",
        "storage_key": "property/6737460151191770/019e1e22-c34c-7579-a241-ede517221837.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.childtime.com/your-local-school/oklahoma-city-ok-0405/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=405",
      "poi_directions_map_url": "https://maps.google.com/?cid=16252440283238027807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childtime-on-south-western",
      "poi_latitude": "35.3659332",
      "poi_longitude": "-97.5294016",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 877-220-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdZqwf3wTsocRH9KmF1REjOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_585a6642-d8c4-449e-86e9-c145ef451cd4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Step Into Learning Childcare - Oklahoma City",
      "poi_type": "Education",
      "poi_address": "10901 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stepintolearningokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2194843171648017524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "step-into-learning-childcare---oklahoma-city",
      "poi_latitude": "35.3590512",
      "poi_longitude": "-97.5305308",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-241-5588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZepJBGQTsocRdJTFXzymdR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_d7a3d446-247c-4768-9e24-020aeab35506",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Pointe Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "1500 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.thepointeperformingartscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15240491686244020984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pointe-performing-arts-center",
      "poi_latitude": "35.3482936",
      "poi_longitude": "-97.5419844",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-912-3269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUzztQUETsocR-HLe6HAagdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_school"
    },
    {
      "id": "custom_19fb1840-b951-4d8e-8714-c4a6c3dacd3a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "The Station at Central Park",
      "poi_type": "Entertainment",
      "poi_address": "700 S Broadway Ave, Moore, OK 73160, USA",
      "poi_short_description": "Clean park featuring a playground, swings, picnic tables and a gym.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c697-727a-b986-3d9084c1dc80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c697-727a-b986-3d9084c1dc80",
        "storage_key": "property/6737460151191770/019e1e22-c697-727a-b986-3d9084c1dc80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cityofmoore.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13916327280658308319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "multi-purpose-pavilion-and-amphitheatre-at-central-park",
      "poi_latitude": "35.3315309",
      "poi_longitude": "-97.4855719",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "60",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbvHHhlrsocR31y3De65IME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c8120e90-c0ba-414e-a943-9e217af8422a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Regal Warren Moore",
      "poi_type": "Entertainment",
      "poi_address": "1000 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Retro-style multiplex chain showing new releases; some locations feature '40s-style diners & IMAX.",
      "poi_long_description": "Retro-style multiplex chain showing new releases; some locations feature '40s-style diners & IMAX.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c4db-743f-b03d-22758e69aeec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c4db-743f-b03d-22758e69aeec",
        "storage_key": "property/6737460151191770/019e1e22-c4db-743f-b03d-22758e69aeec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-moore-1447?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9073693325050595022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-warren-moore",
      "poi_latitude": "35.3290077",
      "poi_longitude": "-97.4934055",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070a-75a9-a7a4-0b750761e5a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070a-75a9-a7a4-0b750761e5a8",
        "storage_key": "property/6737460151191770/019e1e23-070a-75a9-a7a4-0b750761e5a8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6QzNZtrsocRzkZ5MAE87H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f5d99a34-ea7e-4565-8940-2094af6f6163",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "HeyDay Entertainment Norman",
      "poi_type": "Entertainment",
      "poi_address": "3201 Market Pl, Norman, OK 73072, USA",
      "poi_short_description": "Bi-level laser tag arena with bridges & ramps, plus mini-golf, a ropes course, arcade & pizza place.",
      "poi_long_description": "Bi-level laser tag arena with bridges & ramps, plus mini-golf, a ropes course, arcade & pizza place.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c550-74aa-a7a9-8363978c4abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c550-74aa-a7a9-8363978c4abe",
        "storage_key": "property/6737460151191770/019e1e22-c550-74aa-a7a9-8363978c4abe.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.heydayfun.com/heyday-norman",
      "poi_directions_map_url": "https://maps.google.com/?cid=502273123883228578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heyday-entertainment-norman",
      "poi_latitude": "35.2940793",
      "poi_longitude": "-97.4896601",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-310-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl5TEAAdrsocRoh1Jub5u-AY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_a861db10-4ab4-406d-9a1f-ec46c54e123b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c91d-72bb-9241-261963b44610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c91d-72bb-9241-261963b44610",
        "storage_key": "property/6737460151191770/019e1e22-c91d-72bb-9241-261963b44610.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-065c-70df-9849-837a8e7d14d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-065c-70df-9849-837a8e7d14d6",
        "storage_key": "property/6737460151191770/019e1e21-065c-70df-9849-837a8e7d14d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_24349056-a382-4596-b44a-3c8cabad55e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ce37-742c-a3ba-9326e280fc24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ce37-742c-a3ba-9326e280fc24",
        "storage_key": "property/6737460151191770/019e1e22-ce37-742c-a3ba-9326e280fc24.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 35 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_ebcd7ad5-2e29-49b8-b897-e7b9303a7411",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Remington Park",
      "poi_type": "Entertainment",
      "poi_address": "1 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Lively horse racing track with restaurants & bars, plus a second-level casino with electronic games.",
      "poi_long_description": "Lively horse racing track with restaurants & bars, plus a second-level casino with electronic games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ca08-760b-acf1-f92a25e3daa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ca08-760b-acf1-f92a25e3daa0",
        "storage_key": "property/6737460151191770/019e1e22-ca08-760b-acf1-f92a25e3daa0.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "http://www.remingtonpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1963587436471365550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "remington-park",
      "poi_latitude": "35.52789",
      "poi_longitude": "-97.471225",
      "poi_miles_from_property": "15.2",
      "poi_walking_minutes": "5 hours 39 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-424-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzmvujcYsocRrq9LtF4QQBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_729b5d04-4512-4439-b496-d7724cf9878d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Oklahoma City Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "415 Couch Dr, Oklahoma City, OK 73102, USA",
      "poi_short_description": "American art from the colonial era to 1960, plus European paintings & contemporary exhibitions.",
      "poi_long_description": "American art from the colonial era to 1960, plus European paintings & contemporary exhibitions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c9f5-7597-9b50-129535d287f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c9f5-7597-9b50-129535d287f1",
        "storage_key": "property/6737460151191770/019e1e22-c9f5-7597-9b50-129535d287f1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.okcmoa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9657734537123882826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-city-museum-of-art",
      "poi_latitude": "35.4695638",
      "poi_longitude": "-97.5205029",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-236-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-065c-70df-9849-837a8e7d14d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-065c-70df-9849-837a8e7d14d6",
        "storage_key": "property/6737460151191770/019e1e21-065c-70df-9849-837a8e7d14d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_PiwXsocRSmdKhGQqB4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_0a109978-84f3-4183-95c9-fe135b0c5362",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Civic Center Music Hall",
      "poi_type": "Entertainment",
      "poi_address": "201 N Walker Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Local music & dance groups & touring Broadway shows presented in 3 theaters in an art deco building.",
      "poi_long_description": "Local music & dance groups & touring Broadway shows presented in 3 theaters in an art deco building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-cd2a-72e1-854e-b6c177179221.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-cd2a-72e1-854e-b6c177179221",
        "storage_key": "property/6737460151191770/019e1e22-cd2a-72e1-854e-b6c177179221.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcciviccenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6596346278369588838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "civic-center-music-hall",
      "poi_latitude": "35.4690541",
      "poi_longitude": "-97.5235626",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-594-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_R4kSwXsocRZnawwf3tils",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_4179b765-5109-4a40-8ae6-7ab2c8951c8c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "INTEGRIS Health Southwest Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 S Western Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-eef7-7144-a174-42b2f97ca2b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-eef7-7144-a174-42b2f97ca2b1",
        "storage_key": "property/6737460151191770/019e1e20-eef7-7144-a174-42b2f97ca2b1.webp",
        "width": 683,
        "height": 384
      },
      "poi_business_url": "https://integrishealth.org/locations/hospital/integris-health-southwest-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12771302873382817443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "integris-health-southwest-medical-center",
      "poi_latitude": "35.4212648",
      "poi_longitude": "-97.5330065",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-636-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0659-72af-88ec-66a039700fe4",
        "storage_key": "property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28Mb51YRsocRo47oTkzIPLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_224034c5-e6d8-4b4c-93ac-e9665d1b9291",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Oklahoma Center for Orthopedic & Multi-Specialty Surgery",
      "poi_type": "Health and Wellness",
      "poi_address": "8100 S Walker Ave Bldg C, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-cdd3-7024-98e1-197ff43f88b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-cdd3-7024-98e1-197ff43f88b3",
        "storage_key": "property/6737460151191770/019e1e22-cdd3-7024-98e1-197ff43f88b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ocomhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15940073535775917280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-center-for-orthopedic--multi-specialty-surgery",
      "poi_latitude": "35.3849944",
      "poi_longitude": "-97.5198849",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-602-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2y583kUsocR4ESHOW2ENt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5a50d8a0-74b5-40b0-8fe8-b5466fd6ebe7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Access Medical Center Urgent Care, Oklahoma City (S Western Ave)",
      "poi_type": "Health and Wellness",
      "poi_address": "11601 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-cc5f-738e-82ca-272fd4ff86af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-cc5f-738e-82ca-272fd4ff86af",
        "storage_key": "property/6737460151191770/019e1e22-cc5f-738e-82ca-272fd4ff86af.webp",
        "width": 512,
        "height": 289
      },
      "poi_business_url": "https://nextcare.com/locations/ok/oklahoma-city/?utm_source=google&utm_medium=organic&utm_campaign=google_maps&utm_content=western",
      "poi_directions_map_url": "https://maps.google.com/?cid=79798394577784717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "access-medical-center-urgent-care-oklahoma-city-s-western-ave",
      "poi_latitude": "35.35146599999999",
      "poi_longitude": "-97.530475",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-691-5208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62axdV4TsocRjY90kjeAGwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2169730b-40a7-4580-a630-c0efd0a08bc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Immediate Care of Oklahoma - West Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "11808 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-da13-719d-a277-7aaf9229350a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-da13-719d-a277-7aaf9229350a",
        "storage_key": "property/6737460151191770/019e1e22-da13-719d-a277-7aaf9229350a.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://www.immediatecareok.com/locations-okc-ok-west-moore",
      "poi_directions_map_url": "https://maps.google.com/?cid=562623166923978381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "immediate-care-of-oklahoma---west-moore",
      "poi_latitude": "35.3501207",
      "poi_longitude": "-97.5649303",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-242-0480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2fVWyyETsocRjbboFsrWzgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b42d802b-7118-4f62-83c2-461db1bea1e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Chris' Express Drug",
      "poi_type": "Health and Wellness",
      "poi_address": "12032 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-b6cf-72ca-8709-a716bb051ef9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-b6cf-72ca-8709-a716bb051ef9",
        "storage_key": "property/6737460151191770/019e1e22-b6cf-72ca-8709-a716bb051ef9.webp",
        "width": 1280,
        "height": 936
      },
      "poi_business_url": "http://chrisexpressdrug.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13962171481122631728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chris-express-drug",
      "poi_latitude": "35.3477518",
      "poi_longitude": "-97.5293798",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-735-3950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070c-7399-a94d-d1ec9650cd2c",
        "storage_key": "property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-UZ4wV4TsocRMHBnwfyYw8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d34120cd-7a93-4dec-8c42-7ea8a092f250",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Prairie Gardens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12301 N Western Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-cef9-754a-8e37-117d10f4048a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-cef9-754a-8e37-117d10f4048a",
        "storage_key": "property/6737460151191770/019e1e22-cef9-754a-8e37-117d10f4048a.webp",
        "width": 680,
        "height": 397
      },
      "poi_business_url": "https://www.prairiegardenspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12640367632385465997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-gardens-pharmacy",
      "poi_latitude": "35.595412",
      "poi_longitude": "-97.5321494",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 405-768-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070c-7399-a94d-d1ec9650cd2c",
        "storage_key": "property/6737460151191770/019e1e23-070c-7399-a94d-d1ec9650cd2c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3myGwccsocRjV6u3mOba68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e29dc663-880f-4bc4-a3de-2841ebfeaf90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Club Pilates Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "12301 S Western Ave suite b-5, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Chain Pilates studio offering classes for all levels including beginners.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d1cc-722b-8d8f-c965df742e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d1cc-722b-8d8f-c965df742e5f",
        "storage_key": "property/6737460151191770/019e1e22-d1cc-722b-8d8f-c965df742e5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.clubpilates.com/location/moore",
      "poi_directions_map_url": "https://maps.google.com/?cid=2424047962713874167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates-moore",
      "poi_latitude": "35.3456963",
      "poi_longitude": "-97.5305553",
      "poi_miles_from_property": "0.09",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-759-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGQghgA4TsocR994RaMfyoyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cd290a64-791f-4113-b6ad-46d136d373d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "12201 S Western Ave C-3, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d101-779b-bf12-ce71dbef34bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d101-779b-bf12-ce71dbef34bc",
        "storage_key": "property/6737460151191770/019e1e22-d101-779b-bf12-ce71dbef34bc.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/south-okc-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=16733349797973582922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "35.3467613",
      "poi_longitude": "-97.5305818",
      "poi_miles_from_property": "0.04",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-982-2012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUE4RUUTsocRSuSR8vvMOOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_32564977-7bc2-4abd-bae0-464b355a4fb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Gold's Gym Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "647 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Chain gym offering free weights, cardio equipment, and personal training, plus a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d543-71ab-86d1-04e710a057cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d543-71ab-86d1-04e710a057cb",
        "storage_key": "property/6737460151191770/019e1e22-d543-71ab-86d1-04e710a057cb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.goldsgym.com/moore-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5584160476231951631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym-moore",
      "poi_latitude": "35.3214457",
      "poi_longitude": "-97.498346",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-378-4077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs29BhEdrsocRD-WU8l3sfk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_991564a5-f4bb-42cb-8529-8cf5bbac83cb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Shape Fitness Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "700 N Eastern Ave, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d197-7369-ac53-79d4802d468a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d197-7369-ac53-79d4802d468a",
        "storage_key": "property/6737460151191770/019e1e22-d197-7369-ac53-79d4802d468a.webp",
        "width": 1200,
        "height": 674
      },
      "poi_business_url": "http://www.shapefitness.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9437014606861521849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shape-fitness-moore",
      "poi_latitude": "35.3446882",
      "poi_longitude": "-97.4764658",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-793-8746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4SfuSgVsocRuVMnFskC94I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_89085372-4a33-4239-8633-61a1b29659af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Westmoore Trails Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Westmoore Trails Park, 2206 Lonnie Ln, Moore, OK 73170, USA",
      "poi_short_description": "City park with a splash pad, a fire-truck-themed playground, picnic tables, and a public restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d3ae-75cb-92fb-efb095dd832f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d3ae-75cb-92fb-efb095dd832f",
        "storage_key": "property/6737460151191770/019e1e22-d3ae-75cb-92fb-efb095dd832f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/westmoore-trails-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1200822086244762077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westmoore-trails-park",
      "poi_latitude": "35.3159209",
      "poi_longitude": "-97.5164885",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5soFtBrsocR3QEQQVMtqhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c7739c31-0867-43e1-8805-73ad0f7376a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Earlywine Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3033 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "99-acre facility offering golf, tennis courts, sports fields, a playground & a water park.",
      "poi_long_description": "99-acre facility offering golf, tennis courts, sports fields, a playground & a water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d251-769d-8a98-907fb5f85c9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d251-769d-8a98-907fb5f85c9f",
        "storage_key": "property/6737460151191770/019e1e22-d251-769d-8a98-907fb5f85c9f.webp",
        "width": 1000,
        "height": 629
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/275/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11488186801211006766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earlywine-park",
      "poi_latitude": "35.3526604",
      "poi_longitude": "-97.5677868",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bKmP-ASsocRLl-DVwc9bp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e36fe7ce-d3ca-47a9-950d-978d154ee52b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "South Lakes Event Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4302 SW 119th St, Oklahoma City, OK 73173, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d8e1-766a-962a-8723912aebe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d8e1-766a-962a-8723912aebe5",
        "storage_key": "property/6737460151191770/019e1e22-d8e1-766a-962a-8723912aebe5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/rentals-and-permits/south-lakes-event-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3304856091708832755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-lakes-event-center",
      "poi_latitude": "35.3440846",
      "poi_longitude": "-97.593855",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-297-2691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7u_TXATsocR8zsXBBs13S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_8b27eac3-2849-433a-9fbd-a0603a955211",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Little River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "709 SW 10th St, Moore, OK 73160, USA",
      "poi_short_description": "Family-friendly park with a splash park, a playground and a pirate ship.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-f78e-719d-bd3d-28a2c230169a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-f78e-719d-bd3d-28a2c230169a",
        "storage_key": "property/6737460151191770/019e1e20-f78e-719d-bd3d-28a2c230169a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/little-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13309531068765424630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-river-park",
      "poi_latitude": "35.3275656",
      "poi_longitude": "-97.50192",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cPHdTZrsocR9svJeP3ztLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bccd8c99-c9aa-4503-81f9-53c3b98abd4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Parmele Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1308 N Janeway Ave, Moore, OK 73160, USA",
      "poi_short_description": "Playground with a field, picnic tables & a popular splash pad across from a snow cone shop.",
      "poi_long_description": "Playground with a field, picnic tables & a popular splash pad across from a snow cone shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-d9fa-750b-99a6-79f347c09c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-d9fa-750b-99a6-79f347c09c4e",
        "storage_key": "property/6737460151191770/019e1e22-d9fa-750b-99a6-79f347c09c4e.webp",
        "width": 1280,
        "height": 777
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/parmele-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13790356614257917319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parmele-park",
      "poi_latitude": "35.3500969",
      "poi_longitude": "-97.5020685",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0sGusAUsocRhz3NtkYwYb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cfa39d16-1e25-40a3-bb38-85286be01660",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Veterans Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Veterans Memorial Park, 1900 SE 4th St, Moore, OK 73160, USA",
      "poi_short_description": "Walking trail along a scenic creek for walkers, bikers and those picnicking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-dac3-732c-a24f-e1667ada3fdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-dac3-732c-a24f-e1667ada3fdd",
        "storage_key": "property/6737460151191770/019e1e22-dac3-732c-a24f-e1667ada3fdd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/veterans-memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16854855253819571551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veterans-memorial-park",
      "poi_latitude": "35.3334122",
      "poi_longitude": "-97.4594335",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aaKe7VqsocRX72KcI156Ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3fdc762c-0949-4b7f-a525-103783a0cf1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Madison Place Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "420 Madison Pl Dr, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e10f-72de-91ad-6cb2ead283de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e10f-72de-91ad-6cb2ead283de",
        "storage_key": "property/6737460151191770/019e1e22-e10f-72de-91ad-6cb2ead283de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/madison-place-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1454142257720442594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-place-park",
      "poi_latitude": "35.32896789999999",
      "poi_longitude": "-97.4789505",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6HQ48trsocR4r5P1K0mLhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_1176aba9-7eab-4a25-809c-3c4542711553",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Greenbriar Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1331 NW 6th St, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e057-7288-a9a4-1df70e4f6276.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e057-7288-a9a4-1df70e4f6276",
        "storage_key": "property/6737460151191770/019e1e22-e057-7288-a9a4-1df70e4f6276.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/greenbriar-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993990296024828836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenbriar-park",
      "poi_latitude": "35.3431519",
      "poi_longitude": "-97.518756",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2aeIHoVsocRpMv-3iLI1us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d25430e5-5ff7-49a6-a991-2c469369cb22",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Orr Family Farm",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14400 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Unfussy covered wagons on a 108-acre farm with an indoor pool & dining, plus pedal boats.",
      "poi_long_description": "Unfussy covered wagons on a 108-acre farm with an indoor pool & dining, plus pedal boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ded5-764f-b086-7d1f31f3ef90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ded5-764f-b086-7d1f31f3ef90",
        "storage_key": "property/6737460151191770/019e1e22-ded5-764f-b086-7d1f31f3ef90.webp",
        "width": 1025,
        "height": 1280
      },
      "poi_business_url": "http://www.orrfamilyfarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4420107481637178731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orr-family-farm",
      "poi_latitude": "35.32454",
      "poi_longitude": "-97.526983",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-799-3276",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3rIValssocRa80H-FVgVz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_6f4a2c3f-6e4a-4ecd-8b84-88b6b3183f2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Buck Thomas Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1903 NE 12th St, Moore, OK 73160, USA",
      "poi_short_description": "Expansive, nearly 130-acre park featuring a playground, fishing, a walking trail & more.",
      "poi_long_description": "Expansive, nearly 130-acre park featuring a playground, fishing, a walking trail & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-f0e0-7719-a41b-8444c0d64ded.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-f0e0-7719-a41b-8444c0d64ded",
        "storage_key": "property/6737460151191770/019e1e20-f0e0-7719-a41b-8444c0d64ded.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/buck-thomas-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701592146103086508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buck-thomas-park",
      "poi_latitude": "35.3524633",
      "poi_longitude": "-97.4668896",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060e-71bd-a7c2-d9de1f08c64d",
        "storage_key": "property/6737460151191770/019e1e21-060e-71bd-a7c2-d9de1f08c64d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB31aBTwVsocRrK3BdXbVJb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_809de9c0-c6fe-48f7-86e2-3c390437065e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Will Rogers International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7100 Terminal Dr, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Oklahoma City-area airport featuring art & an outdoor garden with a bronze statue of its namesake.",
      "poi_long_description": "Oklahoma City-area airport featuring art & an outdoor garden with a bronze statue of its namesake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-f66e-772e-b029-29f24013bc4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-f66e-772e-b029-29f24013bc4d",
        "storage_key": "property/6737460151191770/019e1e20-f66e-772e-b029-29f24013bc4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flyokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14888269631623114364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "will-rogers-international-airport",
      "poi_latitude": "35.3888421",
      "poi_longitude": "-97.6001183",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-316-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-08eb-77ae-a6f9-de4309a328d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-08eb-77ae-a6f9-de4309a328d9",
        "storage_key": "property/6737460151191770/019e1e21-08eb-77ae-a6f9-de4309a328d9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X8qew0SsocRfK4hOVnCnc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e10c946d-88c4-430d-85b3-6ce075879255",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Oklahoma City",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 S E K Gaylord Blvd, Oklahoma City, OK 73102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e3b7-71fd-be0b-5d408f26c721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e3b7-71fd-be0b-5d408f26c721",
        "storage_key": "property/6737460151191770/019e1e22-e3b7-71fd-be0b-5d408f26c721.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=18415520422701629828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-city",
      "poi_latitude": "35.46549",
      "poi_longitude": "-97.51275",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VqBFCYXsocRhAEVPUESkf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_stop"
    },
    {
      "id": "custom_d15bb92c-bc73-4101-8d8f-14ad3b4dfb43",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1948 E Reno Ave, Oklahoma City, OK 73117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e614-73b8-aab3-28583a3abeb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e614-73b8-aab3-28583a3abeb7",
        "storage_key": "property/6737460151191770/019e1e22-e614-73b8-aab3-28583a3abeb7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/oklahoma-city-ok/oklahoma-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16344711894024616223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "35.4637492",
      "poi_longitude": "-97.4773124",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5azw7FQWsocRH3lwn94U1OI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_1fe5fdb1-602e-4e56-b599-a627608b4526",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "W I-240 Service Rd @ S Western Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1172287360777858018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-i-240-service-rd--s-western-ave",
      "poi_latitude": "35.39141",
      "poi_longitude": "-97.530218",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1xqAIwTsocR4ivYwSTNRBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_4cf40eca-3072-4ff7-bf81-cb22c403b428",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "SW 104 St @ S Western Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18219723267357201775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sw-104-st--s-western-ave",
      "poi_latitude": "35.3632126",
      "poi_longitude": "-97.5289459",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-Z-WWMTsocRb9W-iMd12fw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_82f5a23f-b955-4f6d-8f0d-df01a05c8452",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "S Western Ave @ SW 21 St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4447976360438990966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s-western-ave--sw-21-st",
      "poi_latitude": "35.4430237",
      "poi_longitude": "-97.53023530000002",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2q2gTYRsocRdghN9e5iuj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a5c9b9d1-cf85-4b92-b188-1a12cac13eba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "S Western Ave @ SW 33 St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3071956213950441705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s-western-ave--sw-33-st",
      "poi_latitude": "35.4303398",
      "poi_longitude": "-97.5302963",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAY5FCk4RsocR6egRkubHoSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_e42468a4-f470-4bfe-9f8b-91d0f756d4fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Tinker AFB CAC/ID Card Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Arnold St Bldg 1, Door 4, Tinker Air Force Base, OK 73145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://idco.dmdc.osd.mil/idco/locator",
      "poi_directions_map_url": "https://maps.google.com/?cid=70169305400851678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tinker-afb-cacid-card-office",
      "poi_latitude": "35.4309184",
      "poi_longitude": "-97.3928671",
      "poi_miles_from_property": "13.2",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-739-7646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn7GVQ8Y9socR3ryNipxK-QA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_875254ef-16e3-4f60-bc32-d65fa56285d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "The University of Oklahoma",
      "poi_type": "Education",
      "poi_address": "660 Parrington Oval, Norman, OK 73019, USA",
      "poi_short_description": "Founded in 1890, this research school is home to a sprawling museum dedicated to natural history.",
      "poi_long_description": "Founded in 1890, this research school is home to a sprawling museum dedicated to natural history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e2fd-75cb-af30-e66adc6ddda3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e2fd-75cb-af30-e66adc6ddda3",
        "storage_key": "property/6737460151191770/019e1e22-e2fd-75cb-af30-e66adc6ddda3.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://www.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5385970366617493076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-oklahoma",
      "poi_latitude": "35.1987162",
      "poi_longitude": "-97.4448963",
      "poi_miles_from_property": "13.9",
      "poi_walking_minutes": "500",
      "poi_biking_minutes": "300 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-325-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu1B_5itosocRVB4EKYPPvko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a69ac057-38e3-4429-9e2d-1482fbc15981",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "OU Health University of Oklahoma Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "700 NE 13th St, Oklahoma City, OK 73104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e53e-774e-9331-899e63174c7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e53e-774e-9331-899e63174c7b",
        "storage_key": "property/6737460151191770/019e1e22-e53e-774e-9331-899e63174c7b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ouhealth.com/find-a-location/ou-health-university-of-oklahoma-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13319687687583781516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ou-health-university-of-oklahoma-medical-center",
      "poi_latitude": "35.4802682",
      "poi_longitude": "-97.4967475",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "250",
      "poi_biking_minutes": "400 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-271-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0659-72af-88ec-66a039700fe4",
        "storage_key": "property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ePGKSAXsocRjFKTkWEJ2bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b796bf17-37f6-459e-92f9-5d0c22f9d2da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e80d-77dc-9dce-e6602fd2517f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e80d-77dc-9dce-e6602fd2517f",
        "storage_key": "property/6737460151191770/019e1e22-e80d-77dc-9dce-e6602fd2517f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://integrishealth.org/locations/hospital/integris-health-baptist-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0659-72af-88ec-66a039700fe4",
        "storage_key": "property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_126bdefb-11b7-431f-b3da-7fc2ba9ce5cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-e5be-7729-8deb-3174d7618b32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-e5be-7729-8deb-3174d7618b32",
        "storage_key": "property/6737460151191770/019e1e22-e5be-7729-8deb-3174d7618b32.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "21",
      "poi_walking_minutes": "7 hours 48 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0659-72af-88ec-66a039700fe4",
        "storage_key": "property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_cdd2b090-a2de-47c0-9866-22a542adc401",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Norman Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Healthplex Pkwy, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ff08-7568-a4f2-a816c7288f6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ff08-7568-a4f2-a816c7288f6f",
        "storage_key": "property/6737460151191770/019e1e22-ff08-7568-a4f2-a816c7288f6f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.normanregional.com/locations/norman-regional-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5166678913039723209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norman-regional-hospital",
      "poi_latitude": "35.2599491",
      "poi_longitude": "-97.4885857",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "180",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-515-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0659-72af-88ec-66a039700fe4",
        "storage_key": "property/6737460151191770/019e1e21-0659-72af-88ec-66a039700fe4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp8UVz89rsocRyeo74Bi7s0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_ff7e0ba5-81eb-4093-ae22-a6d0f5abfc6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "The University Of Oklahoma Health Sciences Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 N Lindsay Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ecd7-750a-96cc-3c86bb838cf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ecd7-750a-96cc-3c86bb838cf0",
        "storage_key": "property/6737460151191770/019e1e22-ecd7-750a-96cc-3c86bb838cf0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ouhsc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10936737878310700349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-oklahoma-health-sciences-center",
      "poi_latitude": "35.4796467",
      "poi_longitude": "-97.5006758",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-271-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmZRimRcXsocRPcVEricZx5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_56defac1-c274-4299-8b86-f0a82c457a28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Oklahoma City VA Health Care System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "921 NE 13th St, Oklahoma City, OK 73104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-efe6-752c-a1ff-4de3a39ede3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-efe6-752c-a1ff-4de3a39ede3c",
        "storage_key": "property/6737460151191770/019e1e22-efe6-752c-a1ff-4de3a39ede3c.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "https://www.va.gov/oklahoma-city-health-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816855474429366387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oklahoma-city-va-health-care-system",
      "poi_latitude": "35.4827737",
      "poi_longitude": "-97.4952845",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-456-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0664-777c-8cb8-736236b52151.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0664-777c-8cb8-736236b52151",
        "storage_key": "property/6737460151191770/019e1e21-0664-777c-8cb8-736236b52151.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6SyDxMXsocRcxBSHVfDW3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_398804bf-9753-4d7a-b9af-73ecff5d96bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "MOORE PUBLIC SCHOOLS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 SE 4th St, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ef27-754b-b587-33a44227619f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ef27-754b-b587-33a44227619f",
        "storage_key": "property/6737460151191770/019e1e22-ef27-754b-b587-33a44227619f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2295134488334440699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moore-public-schools",
      "poi_latitude": "35.3335874",
      "poi_longitude": "-97.4661973",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-735-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAQAAlMxqsocR-xjsMKj02R8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_06ac5766-caaf-4e6e-bb5b-615a25d19ab2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Cleveland County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 S Peters Ave #10, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-ee3a-742a-a359-8b9f8a052289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-ee3a-742a-a359-8b9f8a052289",
        "storage_key": "property/6737460151191770/019e1e22-ee3a-742a-a359-8b9f8a052289.webp",
        "width": 1080,
        "height": 755
      },
      "poi_business_url": "http://www.clevelandcountyok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3893467999522613106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cleveland-county-courthouse",
      "poi_latitude": "35.2199652",
      "poi_longitude": "-97.4413042",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-321-6402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0664-777c-8cb8-736236b52151.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0664-777c-8cb8-736236b52151",
        "storage_key": "property/6737460151191770/019e1e21-0664-777c-8cb8-736236b52151.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQE_PdlpsocRcmflX4RgCDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_43309272-a89b-4fd8-94e7-f1cca5ba3b35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Red Oak Elementary School",
      "poi_type": "Education",
      "poi_address": "11224 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea93e-7cda-7607-8d52-629b2ed861d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93e-7cda-7607-8d52-629b2ed861d8",
        "storage_key": "property/6737460151191770/019ea93e-7cda-7607-8d52-629b2ed861d8.webp",
        "width": 1268,
        "height": 947
      },
      "poi_business_url": "https://redoak.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13251200634627499595&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-oak-elementary-school",
      "poi_latitude": "35.3556251",
      "poi_longitude": "-97.5455398",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 405-735-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHelQXhMTsocRSyZn8sS45bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_bc1a84b2-75e6-49fc-86e5-6a83207a3078",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Mid-America Christian University",
      "poi_type": "Education",
      "poi_address": "3500 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea93e-7c9f-76fb-bc00-f841157d3e02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93e-7c9f-76fb-bc00-f841157d3e02",
        "storage_key": "property/6737460151191770/019ea93e-7c9f-76fb-bc00-f841157d3e02.webp",
        "width": 1280,
        "height": 453
      },
      "poi_business_url": "https://www.macu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1537180270262459685&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mid-america-christian-university",
      "poi_latitude": "35.3477803",
      "poi_longitude": "-97.5784864",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 405-691-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIw1jLcMSsocRJZ27vE8pVRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d3f760e8-a91d-40d4-bc8e-6af9a7dc8e90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Oklahoma City Community College",
      "poi_type": "Education",
      "poi_address": "7777 S May Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-dea8-76cd-9c4d-646a6c86232f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-dea8-76cd-9c4d-646a6c86232f",
        "storage_key": "property/6737460151191770/019e1e20-dea8-76cd-9c4d-646a6c86232f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.occc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12663331797127596950&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-community-college",
      "poi_latitude": "35.3880406",
      "poi_longitude": "-97.5699184",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 405-682-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq1zRlkwSsocRlguzIC0xva8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_20dc49e8-3308-4555-acfc-c3f07624ca5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Cornerstone Christian Academy - South OKC",
      "poi_type": "Education",
      "poi_address": "1414 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea93f-5cde-7301-8ed6-c17481be11db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93f-5cde-7301-8ed6-c17481be11db",
        "storage_key": "property/6737460151191770/019ea93f-5cde-7301-8ed6-c17481be11db.webp",
        "width": 1069,
        "height": 714
      },
      "poi_business_url": "https://cornerstonechristian.academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4184615129474536614&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cornerstone-christian-academy---south-okc",
      "poi_latitude": "35.3481672",
      "poi_longitude": "-97.5394007",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 405-562-7090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI8lU_LhtsocRphQOCkq9Ejo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1f551648-772d-4fba-b96e-48f886e421f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Dove Science Academy-South Elementary",
      "poi_type": "Education",
      "poi_address": "7202 S I-35 Service Rd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea93f-5cc4-7680-bbc8-3b671cb861f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea93f-5cc4-7680-bbc8-3b671cb861f5",
        "storage_key": "property/6737460151191770/019ea93f-5cc4-7680-bbc8-3b671cb861f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dsasouth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10869490595026324912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dove-science-academy-south-elementary",
      "poi_latitude": "35.393483",
      "poi_longitude": "-97.4938624",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 405-212-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ZKrzsgVsocRsE3-bRsw2JY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_39477482-fc35-4272-a029-ea7ed9d70c6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, delicious breads, and high-quality meats. They highlight the store is clean, well-organized, and stocks items not found elsewhere, including gluten-free and vegan options. They also like the friendly, helpful, and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-d45e-718d-a728-55fb33e1cbd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-d45e-718d-a728-55fb33e1cbd6",
        "storage_key": "property/6737460151191770/019e1e20-d45e-718d-a728-55fb33e1cbd6.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.sprouts.com/store/ok/moore/moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=463326420679037265&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.3469891",
      "poi_longitude": "-97.5466047",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 405-416-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-063b-717d-887b-03912590086e",
        "storage_key": "property/6737460151191770/019e1e21-063b-717d-887b-03912590086e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9YBcOkTsocRUZGgv-wQbgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5c5629b7-8768-4816-9368-9ea534054c0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "720 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this store offers a good selection of Easter items and sales, and some visitors enjoy shopping there. They also highlight the helpful and friendly staff, with some receiving excellent assistance with price matching.\n\nSome reviews mention the shipping can be careless.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b887-765c-aaae-0e237a0d549e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b887-765c-aaae-0e237a0d549e",
        "storage_key": "property/6737460151191770/019ea947-b887-765c-aaae-0e237a0d549e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/moore/2727",
      "poi_directions_map_url": "https://maps.google.com/?cid=17088900174710079013&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.3176847",
      "poi_longitude": "-97.4998724",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-378-5494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060d-73ac-9fc6-0542f94afd39",
        "storage_key": "property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxT9YezhrsocRJX60Ayv4J-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_922d0c54-1c4a-44b1-9b6e-8bb7e69ee871",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Painted Tree Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "640 SW 19th St Suite 120, Moore, OK 73160, USA",
      "poi_short_description": "Market featuring handcrafted items, clothing and gifts from local vendors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b840-74ef-82e6-5700d094ff95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b840-74ef-82e6-5700d094ff95",
        "storage_key": "property/6737460151191770/019ea947-b840-74ef-82e6-5700d094ff95.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.showplacemarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13422810272311274244&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "showplace-market",
      "poi_latitude": "35.3178743",
      "poi_longitude": "-97.4959688",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-814-1022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060d-73ac-9fc6-0542f94afd39",
        "storage_key": "property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOcn1QidrsocRBOuTWNNmR7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f9ff2460-2636-4009-b648-df3e9b54d13d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "760 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "Reviewers describe the sports store staff as personable, patient, and kind, noting their willingness to answer questions.\n\nOther reviews mention staff can be unhelpful and inventory can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b5bd-70cf-b379-aecad8fcb5c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b5bd-70cf-b379-aecad8fcb5c3",
        "storage_key": "property/6737460151191770/019ea947-b5bd-70cf-b379-aecad8fcb5c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/ok/moore/1080/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=6970934782073878507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dicks-sporting-goods",
      "poi_latitude": "35.3178529",
      "poi_longitude": "-97.5012932",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-237-1585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060d-73ac-9fc6-0542f94afd39",
        "storage_key": "property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJY0vuhEdrsocR67ftLUC8vWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_38c317e5-d173-449b-8d34-b906d3ad1974",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "At Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "621 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Warehouse-sized home decor retailer offering a broad selection of furniture, rugs, lamps, bedding, etc.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b55e-7159-8c7d-b183fa9b93b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b55e-7159-8c7d-b183fa9b93b1",
        "storage_key": "property/6737460151191770/019ea947-b55e-7159-8c7d-b183fa9b93b1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.athome.com/store/oklahoma-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1205571599131703052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "at-home",
      "poi_latitude": "35.322465",
      "poi_longitude": "-97.4971564",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-759-8590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060d-73ac-9fc6-0542f94afd39",
        "storage_key": "property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU9hDhEdrsocRDHeLZfsMuxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_f80033c0-0b05-4664-a7dc-a191f0437df8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "OKC Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7624 W Reno Ave Suite 380, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Relaxed outdoor mall featuring more than 70 brand-name designer stores of shoes, clothing and more.",
      "poi_long_description": "Visitors appreciate this outlet mall for its wide selection of brand-name stores offering great deals, along with its clean and well-maintained outdoor layout. The friendly staff, ample parking, and comfortable seating areas further enhance the positive shopping experience.\n\nSome reviews mention the prices can be similar to regular stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b840-74ef-82e6-58bd160a9168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b840-74ef-82e6-58bd160a9168",
        "storage_key": "property/6737460151191770/019ea947-b840-74ef-82e6-58bd160a9168.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.okcoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773095145334850603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "okc-outlets",
      "poi_latitude": "35.4625898",
      "poi_longitude": "-97.6473972",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-787-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060d-73ac-9fc6-0542f94afd39",
        "storage_key": "property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWyLw68PsocRK0Sn8qNMmxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_34ab7bfa-1bc1-426e-9845-ee7dbec66709",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Sooner Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3301 W Main St, Norman, OK 73072, USA",
      "poi_short_description": "Covered complex for shopping & dining plus a trampoline park & virtual reality experience.",
      "poi_long_description": "This mall is praised for its good selection of stores, diverse food options including sit-down restaurants, and a fun arcade. Visitors also appreciate the clean and peaceful atmosphere, along with the ample parking available.\n\nSome reviews mention the security staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b586-75b6-bce2-104dfba5b5fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b586-75b6-bce2-104dfba5b5fb",
        "storage_key": "property/6737460151191770/019ea947-b586-75b6-bce2-104dfba5b5fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.soonermall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7755349768317849569&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sooner-mall",
      "poi_latitude": "35.2200122",
      "poi_longitude": "-97.4907714",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-360-0341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060d-73ac-9fc6-0542f94afd39",
        "storage_key": "property/6737460151191770/019e1e21-060d-73ac-9fc6-0542f94afd39.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH3uVDQ5psocR4U9-UYaJoGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f94cf5c6-7587-48b8-a20d-9866ef913a15",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Crab and Catfish Co",
      "poi_type": "Restaurants",
      "poi_address": "809 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Casual seafood restaurant known for crab boils, fried catfish and lobster tails, plus daiquiris.",
      "poi_long_description": "Diners like this seafood restaurant's delicious fried catfish, shrimp, and crab legs, noting the generous portions and fresh flavors. They also highlight the friendly and attentive staff, as well as the clean restrooms.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-bb49-7033-bdd0-bd44add48b95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-bb49-7033-bdd0-bd44add48b95",
        "storage_key": "property/6737460151191770/019ea947-bb49-7033-bdd0-bd44add48b95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crabandcatfishco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1345222520784878902&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crab-and-catfish-co",
      "poi_latitude": "35.3494567",
      "poi_longitude": "-97.5283627",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-563-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF13u4bkTsocRNv08X8EwqxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_06f7be7a-c340-4af1-b663-c2d52d1b41f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Bricktown Brewery",
      "poi_type": "Restaurants",
      "poi_address": "1630 SW 104th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Local beers and a wide range of comfort foods are served at this casual chain.",
      "poi_long_description": "Diners say this restaurant offers delicious food, including popular items like burgers, chicken pot pie, and pizza, with consistent quality across locations. They also highlight the reasonable prices, excellent service, and relaxing, clean atmosphere.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-bcc7-7229-9b7b-6a342e990619.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-bcc7-7229-9b7b-6a342e990619",
        "storage_key": "property/6737460151191770/019ea947-bcc7-7229-9b7b-6a342e990619.webp",
        "width": 823,
        "height": 1280
      },
      "poi_business_url": "https://bricktownbrewery.com/location/south-okc/?utm_source=gbp&utm_medium=cpc&utm_campaign=bricktown_brewery",
      "poi_directions_map_url": "https://maps.google.com/?cid=5040036816850466028&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-brewery",
      "poi_latitude": "35.3628905",
      "poi_longitude": "-97.5467131",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-676-5771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM033mPATsocR7DRDG8jO8UU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cba9eee0-bc89-4885-bde1-3250ce35b4b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Neighborhood JA.M.",
      "poi_type": "Restaurants",
      "poi_address": "2875 SW 104th St Ste A, Oklahoma City, OK 73159, USA",
      "poi_short_description": "false",
      "poi_long_description": "Reviewers consistently praise this breakfast and brunch spot for its delicious, fresh, and made-from-scratch food, including unique menu items like the good cinnamon roll and good key lime pancakes. The bright and cheerful atmosphere is frequently mentioned, along with the friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b955-73de-8105-59ca0847e053.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b955-73de-8105-59ca0847e053",
        "storage_key": "property/6737460151191770/019ea947-b955-73de-8105-59ca0847e053.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thatsmyjamok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=347862214850867678&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "neighborhood-jam",
      "poi_latitude": "35.3635107",
      "poi_longitude": "-97.5647704",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-759-7226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4izFRQTsocR3nH3Ytfa0wQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_7e96651c-753e-477e-8217-8bb7a6492a4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Oliveto Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "1301 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "Local Italian chain serving pasta, pizza, sandwiches, classic entrees & wine in a stylish space.",
      "poi_long_description": "Guests consistently praise this Italian restaurant for its reasonable prices, friendly staff, inviting atmosphere, and delicious menu items like the salmon, rigatoni rustica, and jalapeño risotto. These popular dishes contribute to the overall positive dining experience.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-b5b6-717b-b712-59413c02ed4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-b5b6-717b-b712-59413c02ed4e",
        "storage_key": "property/6737460151191770/019ea947-b5b6-717b-b712-59413c02ed4e.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.olivetobistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3620285500518167837&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oliveto-italian-bistro",
      "poi_latitude": "35.3261708",
      "poi_longitude": "-97.4910658",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-735-5553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-060c-71cc-a11a-b92db8ad87f1",
        "storage_key": "property/6737460151191770/019e1e21-060c-71cc-a11a-b92db8ad87f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJERfyOS5rsocRHfXhS3vWPTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c96cce2c-5682-4ed4-879c-73b25eac1c06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Toby Keith's I Love This Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1199 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "Classic American eats & occasional live music in an airy space with murals, neon signs & a patio.",
      "poi_long_description": "People say this bar and grill serves delicious catfish, chicken fried steak, and ribs. They also highlight the generous portions, good prices, and friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-bfe6-745e-a370-4ebbc74fd2e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-bfe6-745e-a370-4ebbc74fd2e1",
        "storage_key": "property/6737460151191770/019ea947-bfe6-745e-a370-4ebbc74fd2e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tobykeithsbar.com/locations/moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4650339265259603488&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "toby-keiths-i-love-this-bar--grill",
      "poi_latitude": "35.3280053",
      "poi_longitude": "-97.4910162",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-799-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070a-75a9-a7a4-05d433ca01d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070a-75a9-a7a4-05d433ca01d0",
        "storage_key": "property/6737460151191770/019e1e23-070a-75a9-a7a4-05d433ca01d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVQR8GnNrsocRIIbZVuxSiUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_0383b58a-a569-4784-9ca5-0c76dee5a1c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2800 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Reviewers describe this amusement center as a fun place for both kids and adults, highlighting the good go-karts and trampolines, and praise the friendly staff, particularly for providing a good birthday party service.\n\nOther reviews mention the staff can be unhelpful and the attractions can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-bd9a-70d7-bdf0-71debb465536.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-bd9a-70d7-bdf0-71debb465536",
        "storage_key": "property/6737460151191770/019ea947-bd9a-70d7-bdf0-71debb465536.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-moore/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=454199799262834417&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.3130452",
      "poi_longitude": "-97.4932574",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-655-5805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSyRgFtrsocR8W4dnE-kTQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1564c048-1806-40e5-a2cf-ebfaa5fbf01e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Jump!Zone",
      "poi_type": "Entertainment",
      "poi_address": "10400 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Kid-friendly play area featuring inflatable slides and bounce houses, plus arcade games.",
      "poi_long_description": "People say this indoor play place is a fun and affordable spot for kids, featuring numerous inflatables and bounce houses. Visitors also highlight the clean environment and friendly, helpful staff.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-be00-728d-81d5-30ac1d698775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-be00-728d-81d5-30ac1d698775",
        "storage_key": "property/6737460151191770/019ea947-be00-728d-81d5-30ac1d698775.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jumpzoneparty.com/JumpZone_Home.php?jzpcity=Oklahoma+City&jzpid=015",
      "poi_directions_map_url": "https://maps.google.com/?cid=18109759286144201479&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jumpzone",
      "poi_latitude": "35.3640165",
      "poi_longitude": "-97.5284773",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-200-1691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX-h9SmMTsocRB_N0Ah_KUvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_f11805f7-15f1-4083-a0ac-b2764b8c9f4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "YMCA Healthy Living Center (50+)",
      "poi_type": "Health and Wellness",
      "poi_address": "13660 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c556-7464-88fe-bc2413596241.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c556-7464-88fe-bc2413596241",
        "storage_key": "property/6737460151191770/019ea947-c556-7464-88fe-bc2413596241.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/hlc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6236207115595183219&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ymca-healthy-living-center-50",
      "poi_latitude": "35.3315724",
      "poi_longitude": "-97.529053",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-272-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfA5IJ9tsocRc3TQrlR1i1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_799c8bf9-a9a5-4ba9-bb01-a95293ecfa67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "JR's Pub & Grill",
      "poi_type": "Restaurants",
      "poi_address": "4041 SW 149th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Chill fixture known for a grilled onion cheeseburger along with karaoke.",
      "poi_long_description": "People say this pub offers a great range of food, drinks, and activities, including karaoke, pool, and golf. They also highlight the friendly and helpful staff, and the lively atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c0d2-725a-8291-34c714a4d7be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c0d2-725a-8291-34c714a4d7be",
        "storage_key": "property/6737460151191770/019ea947-c0d2-725a-8291-34c714a4d7be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jrspubandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7470849839310155821&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jrs-pub--grill",
      "poi_latitude": "35.320118",
      "poi_longitude": "-97.5960217",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-691-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e23-070a-75a9-a7a4-05d433ca01d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e23-070a-75a9-a7a4-05d433ca01d0",
        "storage_key": "property/6737460151191770/019e1e23-070a-75a9-a7a4-05d433ca01d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1Xm1EltsocRLbBduljKrWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_b0d14e3a-fae1-4618-8b58-48cffbc9599a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Earlywine Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "11600 S Portland Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this golf course offers two beautiful courses and a brand new clubhouse with good food. They also highlight the affordable prices, easy location, and well-maintained courses.\n\nOther reviews mention the greens can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-f6b7-72c5-9583-23be67374ab9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-f6b7-72c5-9583-23be67374ab9",
        "storage_key": "property/6737460151191770/019e1e20-f6b7-72c5-9583-23be67374ab9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okcgolf.com/earlywine-golf-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=12680274809197614446&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "earlywine-golf-course",
      "poi_latitude": "35.3519648",
      "poi_longitude": "-97.5817358",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-691-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-08bc-75f9-8f0c-614e28977798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-08bc-75f9-8f0c-614e28977798",
        "storage_key": "property/6737460151191770/019e1e21-08bc-75f9-8f0c-614e28977798.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJj3nZU-4SsocRbtWOiMFi-a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ebb50c18-c190-4924-9de2-d6bbd0632bd6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Moore Escape Rooms",
      "poi_type": "Entertainment",
      "poi_address": "629 N Broadway Ave, Moore, OK 73160, USA",
      "poi_short_description": "Entertainment venue at the Sooner Shopping Center providing themed escape rooms with puzzles.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c56c-762e-b570-4a99324a5ad7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c56c-762e-b570-4a99324a5ad7",
        "storage_key": "property/6737460151191770/019ea947-c56c-762e-b570-4a99324a5ad7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mooreescaperooms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14060662904759324076&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "moore-escape-rooms",
      "poi_latitude": "35.344153",
      "poi_longitude": "-97.488474",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX5_hmdAUsocRrA2xUGqCIcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_96444e14-581c-4a13-81a0-5f97390959de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Twisted Axes Throw House",
      "poi_type": "Entertainment",
      "poi_address": "609 NW 8th St, Moore, OK 73160, USA",
      "poi_short_description": "Amusement center for throwing axes, cards, and ninja stars, with active military discounts.",
      "poi_long_description": "People say this axe throwing venue offers a fun experience with axe throwing, cornhole, and options to add ninja stars and knives. Visitors highlight the friendly and accommodating staff, who provide helpful guidance. They also mention the clean establishment and fun atmosphere, making it great for families, friends, and team events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c3d5-77ed-b9f6-bcf4efd7081d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c3d5-77ed-b9f6-bcf4efd7081d",
        "storage_key": "property/6737460151191770/019ea947-c3d5-77ed-b9f6-bcf4efd7081d.webp",
        "width": 1280,
        "height": 299
      },
      "poi_business_url": "http://www.twistedaxesthrowhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10596440198957847533&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "twisted-axes-throw-house",
      "poi_latitude": "35.3474705",
      "poi_longitude": "-97.4961101",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-676-8697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ67pOigMVsocR7VON9jceDpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_6645e31d-80e6-455b-aa1d-284007ba95f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "I 35 Bingo",
      "poi_type": "Entertainment",
      "poi_address": "713 N Moore Ave, Moore, OK 73160, USA",
      "poi_short_description": "Bingo hall at Nelson Park Shopping Center with glow bingo, other games, and a bar, plus friendly staff.",
      "poi_long_description": "People say this bingo hall offers fun games and delicious food, including a snack bar. Visitors also highlight the friendly, helpful, and kind staff. They also mention the good payouts and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-ca85-74ab-94c9-a03664b2a818.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-ca85-74ab-94c9-a03664b2a818",
        "storage_key": "property/6737460151191770/019ea947-ca85-74ab-94c9-a03664b2a818.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "http://i35bingo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=700512939390301448&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "i-35-bingo",
      "poi_latitude": "35.34500000000001",
      "poi_longitude": "-97.49583330000002",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-735-9669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20NevcUUsocRCHXskM64uAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b798d63-ca2c-41ed-b9c7-85cd1547d10a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Riverwind Casino",
      "poi_type": "Entertainment",
      "poi_address": "1544 OK-9, Norman, OK 73072, USA",
      "poi_short_description": "Straightforward rooms in a lively hotel offering a casino, live entertainment & multiple eateries.",
      "poi_long_description": "Guests consistently praise this casino for its extensive selection of both new and classic slot machines and table games, alongside diverse food options featuring a popular buffet. The well-maintained facilities, friendly staff, and enjoyable atmosphere for both concerts and other events are also frequently highlighted by visitors.\n\nSome reviews mention the slot machine payouts can be low.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e22-c68c-779b-a2f6-88297e5b5cba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e22-c68c-779b-a2f6-88297e5b5cba",
        "storage_key": "property/6737460151191770/019e1e22-c68c-779b-a2f6-88297e5b5cba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.riverwind.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4872672949257126773&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwind-casino",
      "poi_latitude": "35.1811021",
      "poi_longitude": "-97.5005294",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-322-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-tD3uposocRdUMgFzs2n0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_013fedff-80d7-47bb-88c7-8d4f96186cc2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Newcastle Casino",
      "poi_type": "Entertainment",
      "poi_address": "2457 Highway, 62 N Service Rd, Newcastle, OK 73065, USA",
      "poi_short_description": "Cards, electronic games & American bites plus bands, dancing & free outdoor summer concerts.",
      "poi_long_description": "People say this casino offers a huge variety of slot machines and table games, has good food, and features friendly, attentive staff.\n\nOther reviews mention slot payouts can be low and the atmosphere can be overly smoky.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c4ba-7543-89ff-fe257fe90a88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c4ba-7543-89ff-fe257fe90a88",
        "storage_key": "property/6737460151191770/019ea947-c4ba-7543-89ff-fe257fe90a88.webp",
        "width": 1000,
        "height": 665
      },
      "poi_business_url": "http://www.newcastlecasino.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8052078054830381871&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "newcastle-casino",
      "poi_latitude": "35.2769211",
      "poi_longitude": "-97.5984268",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-387-6013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQeucpttsocRLxviQVS6vm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_879f0d1e-e21c-41ff-867b-a35998ca5d03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "OKANA Resort & Indoor Waterpark",
      "poi_type": "Entertainment",
      "poi_address": "639 First Americans Blvd, Oklahoma City, OK 73129, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this resort hotel has a large indoor water park with numerous slides, a lazy river, and a hot tub, as well as several restaurants, a spa, and an arcade. They like the friendly and helpful staff, the clean and comfortable rooms, and the fun, family-friendly atmosphere.\n\nSome reviews mention the wait times for food and drinks can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c558-70af-af97-822e98ef84b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c558-70af-af97-822e98ef84b9",
        "storage_key": "property/6737460151191770/019ea947-c558-70af-af97-822e98ef84b9.webp",
        "width": 1000,
        "height": 500
      },
      "poi_business_url": "https://www.okanaresort.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4367419904320407383&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "okana-resort--indoor-waterpark",
      "poi_latitude": "35.4593974",
      "poi_longitude": "-97.4803789",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 572-228-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-d25e-75d1-96d6-72ca51294fe2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ea947-d25e-75d1-96d6-72ca51294fe2",
        "storage_key": "property/6737460151191770/019ea947-d25e-75d1-96d6-72ca51294fe2.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ0d4KGVQWsocRVwf9bUMxnDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_05d68458-ed71-448f-bf7e-2b67102d1af9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "SSM Health St. Anthony Healthplex",
      "poi_type": "Health and Wellness",
      "poi_address": "13500 S Tulsa Dr, Oklahoma City, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c8a2-742f-afde-c94a58e4947b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c8a2-742f-afde-c94a58e4947b",
        "storage_key": "property/6737460151191770/019ea947-c8a2-742f-afde-c94a58e4947b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ssmhealth.com/locations/location-details/st-anthony-healthplex-south?utm_id=sys-listings-1&linksource=sys_listing_links-gmb_listing&y_source=1_MjMyNTc3NTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15753166672115018555&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ssm-health-st-anthony-healthplex",
      "poi_latitude": "35.3330346",
      "poi_longitude": "-97.5907271",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-815-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUS6wbLYSsocROyvw2p99nto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_7e65c7eb-c5d8-4170-b65c-cd87cd02ae5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Amazon OKC1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 S Portland Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this delivery service offers convenient truck parking, easy delivery entry with license plate recognition, and a completely automated check-in process.\n\nOther reviews mention deliveries can be delayed and packages can be delivered to the wrong address.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-c8f7-7470-b56a-43eef7c98a22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-c8f7-7470-b56a-43eef7c98a22",
        "storage_key": "property/6737460151191770/019ea947-c8f7-7470-b56a-43eef7c98a22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11238927909774133689&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amazon-okc1",
      "poi_latitude": "35.3742372",
      "poi_longitude": "-97.5802785",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 833-774-2812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0611-7737-8df7-bdfd71e59625",
        "storage_key": "property/6737460151191770/019e1e21-0611-7737-8df7-bdfd71e59625.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZ4ERwgTsocRuYlPNmOx-Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_60792320-9d2c-495f-aec4-c4388419ed81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Boeing Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6001 S Air Depot Blvd, Oklahoma City, OK 73135",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14c8448f-ed59-492c-a61c-6cd809d0103c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Mike Monroney Aeronautical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6500 S MacArthur Blvd, Oklahoma City, OK 73169, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019ea947-cb97-771a-afd8-c48289c41e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea947-cb97-771a-afd8-c48289c41e74",
        "storage_key": "property/6737460151191770/019ea947-cb97-771a-afd8-c48289c41e74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.faa.gov/about/office_org/headquarters_offices/afn/offices/mmac",
      "poi_directions_map_url": "https://maps.google.com/?cid=10722323880258901890&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mike-monroney-aeronautical-center",
      "poi_latitude": "35.4022102",
      "poi_longitude": "-97.6266403",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-954-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e21-0674-752d-bf76-7ba1739a31ce",
        "storage_key": "property/6737460151191770/019e1e21-0674-752d-bf76-7ba1739a31ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ11hpUvENsocRgheFgcJYzZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_01187196-86cf-4552-8a55-f36f261c6f40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Will Rogers World Airport",
      "poi_type": "Entertainment",
      "poi_address": "7100 Terminal Drive, Oklahoma City, OK 73159",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_652f64c8-fd2e-464e-95a4-647e2fb75620",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "Tinker Air Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4385 S. Air Depot Blvd., Bldg 1002, Tinker AFB, OK 73145",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e0c9770a-ef0c-4fe5-bf86-d1717932af11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "poi_name": "UPS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8825 N I-35 Service Rd, Oklahoma City, OK 73131",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_75ff8d21-e8e3-4aea-81fd-68337aeec0e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_73f5eedc-038c-48f6-b618-a5005259d430",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_824f9be6-95c9-4b18-a2f9-2214f68a8c72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4de32060-044b-4b43-9672-917fcba2c18d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c8c7986c-3ba9-427e-a7ee-09a3893531c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a7fe38ec-0e35-4df9-91e0-2d2de8884318",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_07a5627a-823f-4a35-94ac-1c8614119c4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "rating": "5",
      "name": "Tasha Stinnett-Garton",
      "text": "The office staff are truly ONE OF A KIND! Lynsey treats everyone like family. I have first handedly witnessed her put 1000% into events for the residence. Every resident that came in, she knew on a personal level and they talked with one another as such. I’ve never encountered an apartment office manager who cared so much about making the place people lived truly feel like home and welcoming. I wish I could rate this place 100 stars",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_5758ffc3-4a8c-47f3-97e1-eb6935b43059",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "rating": "5",
      "name": "Michael Doutey",
      "text": "Great experience touring The Traditions. Lynsey was very communicative and answered all my questions. Very pleased with me experience thus far.",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_f5efa9dc-25a2-42ce-a55d-01dfb291c40d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "rating": "5",
      "name": "tristan yonash",
      "text": "I love living here, Lynsey made the move in process super easy",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_a5b0934e-a239-44ce-93ae-66b4b6e64758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "rating": "5",
      "name": "Alexandra Burke",
      "text": "Lynsey is amazing! The taco party was so fun!",
      "date": "2026-04-10",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_c6453c8d-6ced-4b39-a52d-c0ec4639ceab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019e1e20-b8da-7758-a553-0662dca96aba.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e20-b8da-7758-a553-0662dca96aba",
        "storage_key": "property/6737460151191770/019e1e20-b8da-7758-a553-0662dca96aba.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Clubroom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6683751f99887f11fadc99fd"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993ff9-b6a3-7028-bcab-6af6ce80c114",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-traditions-at-westmoore-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770"
    },
    {
      "lead_collector_id": "019a270f-dd44-7556-b2ef-fd19c6e64370",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-traditions-at-westmoore-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "in-unit-laundry-oklahoma-city-apartments",
      "search_query": "apartments with in-unit laundry in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in OKC",
      "h2_subtitle": "Explore Oklahoma City apartments with in-unit laundry for ultimate convenience. Traditions at Westmoore offers this amenity and more.",
      "page_copy": "Discover the convenience of living in an apartment with in-unit laundry at Traditions at Westmoore in Oklahoma City. Our spacious two and three-bedroom floor plans are designed with your lifestyle in mind, featuring modern amenities like premium gas grills and a fully equipped 24-hour fitness center. \n\nLocated in the Outer Moore neighborhood, our gated community adds an extra layer of comfort, with additional features such as door-to-door trash pickup and a community clubhouse. Relax by one of our two sparkling pools or enjoy a meal in the communal picnic area. Experience easy living where your perfect home awaits with the added perk of in-unit laundry.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in OKC",
      "seo_description": "Explore Traditions at Westmoore, offering Oklahoma City apartments with in-unit laundry and premium amenities. Perfect for a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "gated-community-pool-cleveland-county",
      "search_query": "gated community apartments with pool in Cleveland County",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments with Pool",
      "h2_subtitle": "Find your perfect home in Cleveland County's gated community with a pool. Enjoy the premium lifestyle at Traditions at Westmoore.",
      "page_copy": "Experience the tranquility of a gated community apartment with a pool at Traditions at Westmoore, nestled in Cleveland County. Our community offers the ultimate blend of comfort and luxury with spacious two and three-bedroom floor plans, each designed to enhance your lifestyle. \n\nIn addition to two sparkling pools, residents enjoy exclusive access to amenities like a clubhouse, 24-hour fitness center, and door-to-door trash pickup. Whether you're relaxing on your private patio or having a picnic in our designated area, Traditions at Westmoore is dedicated to offering a premium living experience in the heart of Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments with Pool",
      "seo_description": "Discover gated community living in Cleveland County with pools and more at Traditions at Westmoore. Enjoy premium amenities in a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-outer-moore",
      "search_query": "air conditioned apartments near Outer Moore",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Outer Moore",
      "h2_subtitle": "Stay comfortable year-round in air conditioned apartments near Outer Moore. Traditions at Westmoore offers this feature and more in Oklahoma City.",
      "page_copy": "Stay cool and comfortable in the air conditioned apartments at Traditions at Westmoore, conveniently located near Outer Moore. Our community offers an ideal combination of luxury and convenience, featuring spacious two and three-bedroom floor plans tailored to your lifestyle needs. \n\nBeyond air conditioning, our residents enjoy first-class amenities including two sparkling pools, a 24-hour fitness center, and a welcoming clubhouse. Located in Oklahoma City, Traditions at Westmoore provides a gated community experience with the added benefits of door-to-door trash pickup and a peaceful picnic area. Discover the perfect balance of comfort and location in Cleveland County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Outer Moore",
      "seo_description": "Discover air conditioned living near Outer Moore at Traditions at Westmoore. Enjoy cool comfort with premium amenities in an ideal Oklahoma City location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-oklahoma-city",
      "search_query": "apartments with dishwasher in Oklahoma City OK",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in OKC",
      "h2_subtitle": "Looking for Oklahoma City apartments with a dishwasher? Traditions at Westmoore features modern conveniences for easy living.",
      "page_copy": "Simplify daily living in apartments equipped with a dishwasher at Traditions at Westmoore, located in the vibrant city of Oklahoma City, OK. Our spacious two and three-bedroom floor plans are designed to enhance your lifestyle, allowing you more free time to enjoy our premium amenities. \n\nBeyond the convenience of a dishwasher, our gated community offers amenities like a 24-hour fitness center, two refreshing pools, and a welcoming clubhouse. Located in the Outer Moore neighborhood, residents enjoy door-to-door trash pickup, a peaceful picnic area, and accessibility features that ensure a comfortable living experience for everyone. Discover the perfect apartment that meets all your needs in Cleveland County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in OKC",
      "seo_description": "Explore Oklahoma City apartments with a dishwasher at Traditions at Westmoore. Enjoy hassle-free living with premium amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "gated-community-fitness-center-73170",
      "search_query": "gated community with fitness center in 73170",
      "category": "Amenity",
      "h1_title": "Gated Community with Fitness Center in 73170",
      "h2_subtitle": "Discover a gated community with a state-of-the-art fitness center in the 73170 area. Traditions at Westmoore welcomes you with open arms.",
      "page_copy": "Upgrade your lifestyle at Traditions at Westmoore, a top-tier gated community with a fitness center, located in the 73170 area. Our residents enjoy a spacious two and three-bedroom apartment options paired with unmatched community amenities that elevate daily living.\n\nSpend time at our 24-hour fitness center equipped with modern facilities, or enjoy outdoor relaxation with two sparkling pools and a comfortable clubhouse. Nestled within Cleveland County, this community provides essential conveniences like door-to-door trash pickup and a serene picnic area. Discover the quality of life you deserve in Oklahoma City at Traditions at Westmoore.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community with Fitness Center in 73170",
      "seo_description": "Find luxury living at a gated community with a fitness center in the 73170 area. Explore top amenities at Traditions at Westmoore today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "one-bedroom-apartment-traditions-oklahoma-city",
      "search_query": "one bedroom apartment traditions oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments at Traditions OKC",
      "h2_subtitle": "Explore comfortable one bedroom apartments at Traditions in Oklahoma City. Enjoy a community focused on convenience and luxury.",
      "page_copy": "Experience the ideal blend of comfort and style in a one bedroom apartment at Traditions at Westmoore, located in vibrant Oklahoma City. Perfectly sized for those seeking efficiency without sacrificing comfort, our one bedroom units are part of a community designed for modern living.\n\nResidents benefit from a range of amenities including a 24-hour fitness center, two shimmering pools, and a lively clubhouse, all within a secure gated community. Situated near Outer Moore, our Cleveland County location offers convenient access to local attractions, making it easy to see why Traditions at Westmoore is a sought-after choice for renters in the Oklahoma City area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments at Traditions OKC",
      "seo_description": "Discover cozy one bedroom apartments at Traditions in Oklahoma City. Relish luxury amenities and a convenient location today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-cleveland-county",
      "search_query": "two bedroom apartments cleveland county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Cleveland County",
      "h2_subtitle": "Find the ideal two bedroom apartment in Cleveland County at Traditions at Westmoore. Comfort and convenience await you.",
      "page_copy": "Discover spacious two bedroom apartments in Cleveland County at Traditions at Westmoore. Located in Oklahoma City's Outer Moore neighborhood, our apartment homes offer modern amenities and ample living space, perfect for families or roommates seeking comfort and style.\n\nResidents enjoy access to exceptional community features, including a 24-hour fitness center, two sparkling swimming pools, and a welcoming clubhouse. With convenient services like door-to-door trash pickup and accessible options, Traditions at Westmoore provides a relaxed and enjoyable living experience in a gated setting. Elevate your lifestyle at a community where your ideal apartment home is just waiting to be discovered.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Cleveland County",
      "seo_description": "Explore two bedroom apartments in Cleveland County at Traditions at Westmoore. Enjoy modern amenities and an ideal Oklahoma City location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191770",
      "source": "generator",
      "page_item_url": "three-bedroom-apartment-outer-moore-ok",
      "search_query": "three bedroom apartment outer moore ok",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Outer Moore, OK",
      "h2_subtitle": "Spacious three bedroom apartments available in Outer Moore, OK at Traditions at Westmoore. Find comfort and convenience today.",
      "page_copy": "Searching for a three bedroom apartment in Outer Moore, OK? Traditions at Westmoore offers spacious living options perfect for families and those needing extra room. Situated in the vibrant area of Outer Moore, our apartments provide residents with modern amenities and ample living space.\n\nEnjoy premium features within our gated community, including two sparkling swimming pools, a state-of-the-art, 24-hour fitness center, and a cozy clubhouse. Plus, services like door-to-door trash pickup enhance your living experience. Located in Cleveland County, this community blends comfort with convenience, making it a top choice for three bedroom living in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d076f-35f6-71c4-b47d-3770f004a090",
        "storage_key": "property/6737460151191770/019d076f-35f6-71c4-b47d-3770f004a090.webp",
        "width": 1024,
        "height": 672
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Outer Moore, OK",
      "seo_description": "Explore three bedroom apartments in Outer Moore, OK at Traditions at Westmoore. Discover spacious layouts and top amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3410"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483084"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026482"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TXS4DSH9"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_fr_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=fr"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "405-873-7298"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_fr_title",
      "type": "STRING",
      "value": "ForRent"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "405-591-4847"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "405-450-8052"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "405-704-3399"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "405-725-2438"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "405-645-5665"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "405-451-4048"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "405-784-6057"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "405-654-1412"
    },
    {
      "ID": "custom_knock_fr_number",
      "type": "STRING",
      "value": "405-689-7014"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "405-266-5417"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "405-645-5712"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "405-913-4982"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "405-433-7381"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "405-351-7928"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "405-725-3412"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "405-347-8205"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "405-643-8274"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "405-554-9690"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321126840"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "405-294-1470"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "011ee04be7cd81b5"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "405-775-9468"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "405-544-2761"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "405-873-7811"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "405-450-7957"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "405-963-5069"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "405-987-3917"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "405-883-4194"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.traditionswestmoore.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191770/019e84e4-6344-72ec-bcc7-5a022a439cda.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "405-369-8642"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "405-266-5417"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3410",
  "custom_repli_id": "5028483084",
  "custom_realpage_id": "5026482",
  "custom_knock_a_link": "https://www.traditionswestmoore.com?utm_knock=a",
  "custom_knock_g_link": "https://www.traditionswestmoore.com?utm_knock=g",
  "custom_knock_r_link": "https://www.traditionswestmoore.com?utm_knock=r",
  "custom_knock_w_link": "https://www.traditionswestmoore.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-TXS4DSH9",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.traditionswestmoore.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.traditionswestmoore.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.traditionswestmoore.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.traditionswestmoore.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.traditionswestmoore.com?utm_knock=fl",
  "custom_knock_fr_link": "https://www.traditionswestmoore.com?utm_knock=fr",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.traditionswestmoore.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "405-873-7298",
  "custom_knock_ads_link": "https://www.traditionswestmoore.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.traditionswestmoore.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_fr_title": "ForRent",
  "custom_knock_g_number": "405-591-4847",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.traditionswestmoore.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.traditionswestmoore.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.traditionswestmoore.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.traditionswestmoore.com?utm_knock=psa",
  "custom_knock_r_number": "405-450-8052",
  "custom_knock_w_number": "405-704-3399",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "405-725-2438",
  "custom_knock_amap_link": "https://www.traditionswestmoore.com?utm_knock=amap",
  "custom_knock_ar_number": "405-645-5665",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "405-451-4048",
  "custom_knock_fb_number": "405-784-6057",
  "custom_knock_fl_number": "405-654-1412",
  "custom_knock_fr_number": "405-689-7014",
  "custom_knock_gp_number": "405-266-5417",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.traditionswestmoore.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "405-645-5712",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.traditionswestmoore.com?utm_knock=bcard",
  "custom_knock_bnr_number": "405-913-4982",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "405-433-7381",
  "custom_knock_lgp_number": "405-351-7928",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.traditionswestmoore.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "405-725-3412",
  "custom_knock_psa_number": "405-347-8205",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "405-643-8274",
  "custom_knock_bandit_link": "https://www.traditionswestmoore.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_flyers_link": "https://www.traditionswestmoore.com?utm_knock=flyers",
  "custom_knock_osoc_number": "405-554-9690",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321126840",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "405-294-1470",
  "custom_knock_chatgpt_link": "https://www.traditionswestmoore.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "011ee04be7cd81b5",
  "custom_knock_dirmail_link": "https://www.traditionswestmoore.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "405-775-9468",
  "custom_knock_propbro_link": "https://www.traditionswestmoore.com?utm_knock=propbro",
  "custom_knock_bandit_number": "405-544-2761",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "405-873-7811",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.traditionswestmoore.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "405-450-7957",
  "custom_knock_dirmail_number": "405-963-5069",
  "custom_knock_propbro_number": "405-987-3917",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "405-883-4194",
  "custom_knock_maintenance_link": "https://www.traditionswestmoore.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191770/019e84e4-6344-72ec-bcc7-5a022a439cda.mp4",
  "custom_knock_maintenance_number": "405-369-8642",
  "custom_ppc_tracking_phone_number": "405-266-5417"
};

export const generatedAt = '2026-10-07T17:15:38.182Z';
